//https://cdn.haworth.com/haworth-configurator/0.0.33/assets/w-cf/scripts/eaiws.min.js
'use strict';
var egr,
  __extends =
    (this && this.__extends) ||
    (function () {
      var r = function (e, t) {
        return (r =
          Object.setPrototypeOf ||
          ({ __proto__: [] } instanceof Array &&
            function (e, t) {
              e.__proto__ = t;
            }) ||
          function (e, t) {
            for (var o in t) t.hasOwnProperty(o) && (e[o] = t[o]);
          })(e, t);
      };
      return function (e, t) {
        function o() {
          this.constructor = e;
        }
        r(e, t),
          (e.prototype =
            null === t
              ? Object.create(t)
              : ((o.prototype = t.prototype), new o()));
      };
    })(),
  __decorate =
    (this && this.__decorate) ||
    function (e, t, o, r) {
      var a,
        i = arguments.length,
        n =
          i < 3
            ? t
            : null === r
            ? (r = Object.getOwnPropertyDescriptor(t, o))
            : r;
      if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
        n = Reflect.decorate(e, t, o, r);
      else
        for (var s = e.length - 1; 0 <= s; s--)
          (a = e[s]) &&
            (n = (i < 3 ? a(n) : 3 < i ? a(t, o, n) : a(t, o)) || n);
      return 3 < i && n && Object.defineProperty(t, o, n), n;
    },
  __awaiter =
    (this && this.__awaiter) ||
    function (e, n, s, p) {
      return new (s = s || Promise)(function (o, t) {
        function r(e) {
          try {
            i(p.next(e));
          } catch (e) {
            t(e);
          }
        }
        function a(e) {
          try {
            i(p.throw(e));
          } catch (e) {
            t(e);
          }
        }
        function i(e) {
          var t;
          e.done
            ? o(e.value)
            : ((t = e.value) instanceof s
                ? t
                : new s(function (e) {
                    e(t);
                  })
              ).then(r, a);
        }
        i((p = p.apply(e, n || [])).next());
      });
    },
  __generator =
    (this && this.__generator) ||
    function (o, r) {
      var a,
        i,
        n,
        s = {
          label: 0,
          sent: function () {
            if (1 & n[0]) throw n[1];
            return n[1];
          },
          trys: [],
          ops: [],
        },
        e = { next: t(0), throw: t(1), return: t(2) };
      return (
        'function' == typeof Symbol &&
          (e[Symbol.iterator] = function () {
            return this;
          }),
        e
      );
      function t(t) {
        return function (e) {
          return (function (t) {
            if (a) throw new TypeError('Generator is already executing.');
            for (; s; )
              try {
                if (
                  ((a = 1),
                  i &&
                    (n =
                      2 & t[0]
                        ? i.return
                        : t[0]
                        ? i.throw || ((n = i.return) && n.call(i), 0)
                        : i.next) &&
                    !(n = n.call(i, t[1])).done)
                )
                  return n;
                switch (((i = 0), n && (t = [2 & t[0], n.value]), t[0])) {
                  case 0:
                  case 1:
                    n = t;
                    break;
                  case 4:
                    return s.label++, { value: t[1], done: !1 };
                  case 5:
                    s.label++, (i = t[1]), (t = [0]);
                    continue;
                  case 7:
                    (t = s.ops.pop()), s.trys.pop();
                    continue;
                  default:
                    if (
                      !(n = 0 < (n = s.trys).length && n[n.length - 1]) &&
                      (6 === t[0] || 2 === t[0])
                    ) {
                      s = 0;
                      continue;
                    }
                    if (3 === t[0] && (!n || (t[1] > n[0] && t[1] < n[3]))) {
                      s.label = t[1];
                      break;
                    }
                    if (6 === t[0] && s.label < n[1]) {
                      (s.label = n[1]), (n = t);
                      break;
                    }
                    if (n && s.label < n[2]) {
                      (s.label = n[2]), s.ops.push(t);
                      break;
                    }
                    n[2] && s.ops.pop(), s.trys.pop();
                    continue;
                }
                t = r.call(o, s);
              } catch (e) {
                (t = [6, e]), (i = 0);
              } finally {
                a = n = 0;
              }
            if (5 & t[0]) throw t[1];
            return { value: t[0] ? t[1] : void 0, done: !0 };
          })([t, e]);
        };
      }
    };
!(function (e) {
  var i, a, t;
  function o() {
    (this.eventConnected = new i.utils.ListenableEvent(this)),
      (this.eventDisconnected = new i.utils.ListenableEvent(this)),
      (this.eventSessionLocaleChanged = new i.utils.ListenableEvent(this)),
      (this.eventCatalogLanguagesChanged = new i.utils.ListenableEvent(this)),
      (this.eventBasketLanguagesChanged = new i.utils.ListenableEvent(this)),
      (this.mBaseUrl = void 0),
      (this.mSessionId = void 0),
      (this.mSession = void 0),
      (this.mCatalog = void 0),
      (this.mBasket = void 0),
      (this.mProject = void 0),
      (this.mKeepAliveInterval = null);
  }
  (i = e.wcf || (e.wcf = {})),
    (a = i.eaiws || (i.eaiws = {})),
    Object.defineProperty(o.prototype, 'baseUrl', {
      get: function () {
        return this.mBaseUrl;
      },
      enumerable: !1,
      configurable: !0,
    }),
    Object.defineProperty(o.prototype, 'sessionId', {
      get: function () {
        return this.mSessionId;
      },
      enumerable: !1,
      configurable: !0,
    }),
    Object.defineProperty(o.prototype, 'session', {
      get: function () {
        return this.mSession;
      },
      enumerable: !1,
      configurable: !0,
    }),
    Object.defineProperty(o.prototype, 'catalog', {
      get: function () {
        return this.mCatalog;
      },
      enumerable: !1,
      configurable: !0,
    }),
    Object.defineProperty(o.prototype, 'basket', {
      get: function () {
        return this.mBasket;
      },
      enumerable: !1,
      configurable: !0,
    }),
    Object.defineProperty(o.prototype, 'project', {
      get: function () {
        return this.mProject;
      },
      enumerable: !1,
      configurable: !0,
    }),
    Object.defineProperty(o.prototype, 'isValid', {
      get: function () {
        return null != this.mSession;
      },
      enumerable: !1,
      configurable: !0,
    }),
    (o.prototype.open = function (t, o) {
      var r = this,
        e = new Array();
      return (
        i.utils.string.isNotNullOrEmpty(o.startup) &&
          e.push(new a.session.StringPair('-startup', o.startup)),
        i.utils.string.isNotNullOrEmpty(o.packageGroups) &&
          e.push(new a.session.StringPair('-package-groups', o.packageGroups)),
        i.utils.string.isNotNullOrEmpty(o.userToken) &&
          e.push(new a.session.StringPair('-user-token', o.userToken)),
        i.utils.string.isNotNullOrEmpty(o.locale) &&
          e.push(new a.session.StringPair('-locale', o.locale)),
        i.utils.string.isNotNullOrEmpty(o.dataDomain) &&
          e.push(new a.session.StringPair('-domain', o.dataDomain)),
        a.session.SessionService.OpenSession(t, e).then(function (e) {
          return r.connect(t, e, o.keepAliveInterval);
        })
      );
    }),
    (o.prototype.close = function () {
      var e = this;
      return null == this.mSession
        ? Promise.resolve(!1)
        : this.mSession.closeSession().then(function () {
            return e.disconnect();
          });
    }),
    (o.prototype.connect = function (e, t, o) {
      var r = this;
      return (
        void 0 === o && (o = 6e4),
        !i.utils.string.isNullOrEmpty(t) &&
          (this.disconnect(),
          (this.mBaseUrl = e),
          (this.mSessionId = t),
          (this.mSession = new a.session.SessionService(
            this,
            this.mBaseUrl,
            this.mSessionId
          )),
          (this.mCatalog = new a.catalog.CatalogService(
            this,
            this.mBaseUrl,
            this.mSessionId
          )),
          (this.mBasket = new a.basket.BasketService(
            this,
            this.mBaseUrl,
            this.mSessionId
          )),
          (this.mProject = new a.project.ProjectService(
            this,
            this.mBaseUrl,
            this.mSessionId
          )),
          null != o &&
            0 < o &&
            (this.mKeepAliveInterval = setInterval(function () {
              r.keepAlive();
            }, o)),
          this.eventConnected.trigger(),
          !0)
      );
    }),
    (o.prototype.disconnect = function () {
      return (
        null != this.mSession &&
        ((this.mBaseUrl = void 0),
        (this.mSessionId = void 0),
        (this.mSession = void 0),
        (this.mCatalog = void 0),
        (this.mBasket = void 0),
        (this.mProject = void 0),
        null != this.mKeepAliveInterval &&
          (clearInterval(this.mKeepAliveInterval),
          (this.mKeepAliveInterval = null)),
        this.eventDisconnected.trigger(),
        !0)
      );
    }),
    (o.prototype.uploadFileToUrl = function (r, a, i) {
      return new Promise(function (e, t) {
        var o = new XMLHttpRequest();
        o.open('PUT', r),
          (o.onreadystatechange = function () {
            4 === o.readyState &&
              (200 <= o.status && o.status < 300
                ? e(r)
                : 0 === o.status
                ? e('')
                : t(new Error(o.status.toString())));
          }),
          null != i &&
            null != o.upload &&
            (o.upload.onprogress = function (e) {
              return i(e, o);
            }),
          o.setRequestHeader('Content-Type', a.type),
          (o.responseType = 'text'),
          o.send(a);
      });
    }),
    (o.prototype.uploadFile = function (e, t, o, r) {
      var a = this;
      return this.isValid
        ? this.mSession.getUploadURL(e, r).then(function (e) {
            return null != e && '' !== e
              ? a.uploadFileToUrl(e, t, o)
              : Promise.resolve(null);
          })
        : i.utils.rejectError(i.utils.ERR_INVALID_STATE, 'session not valid');
    }),
    (o.prototype.deleteFile = function (e) {
      return i.utils.async.ajax('DELETE', e, null, { responseType: 'text' });
    }),
    (o.prototype._clearCache = function () {
      this.isValid &&
        (this.mSession._clearCache(),
        this.mCatalog._clearCache(),
        this.mBasket._clearCache(),
        this.mProject._clearCache());
    }),
    (o.prototype.keepAlive = function () {
      this.isValid && this.mSession.keepAlive();
    }),
    (t = o),
    (a.EaiwsSession = t);
})((egr = egr || {})),
  (function (e) {
    var l;
    (function (e) {
      var o,
        s = ((o = l.utils.CustomError), __extends(r, o), r);
      function r(e) {
        var t = o.call(this, e) || this;
        return Object.setPrototypeOf(t, r.prototype), t;
      }
      e.SoapError = s;
      var t =
        (Object.defineProperty(u.prototype, 'url', {
          get: function () {
            return this.mUrl;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(u.prototype, 'namespaceUrl', {
          get: function () {
            return this.mNamespaceUrl;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(u.prototype, 'sessionId', {
          get: function () {
            return this.mSessionId;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (u.SoapDataToArray = function (e, t) {
          if (null != e) {
            var o = new Array();
            if (Array.isArray(e))
              for (var r = 0; r < e.length; ++r) {
                var a = null == t ? e[r] : t(e[r]);
                o.push(a);
              }
            else (a = null == t ? e : t(e)), o.push(a);
            return o;
          }
        }),
        (u.SoapDataToArrayNU = function (e, t) {
          var o = u.SoapDataToArray(e, t);
          return null == o ? [] : o;
        }),
        (u.SoapDataToBool = function (e) {
          if (null != e) return 'true' === e;
        }),
        (u.SoapDataToFloat = function (e) {
          if (null != e) return parseFloat(e);
        }),
        (u.SoapDataToInt = function (e) {
          if (null != e) return parseInt(e);
        }),
        (u.GetSoapDataNodeValue = function (e) {
          if (null != e) return e[u.NODE_TEXT_KEY];
        }),
        (u.SerializeDataToXml = function (e) {
          return l.utils.string.isString(e)
            ? e
            : l.utils.object.isPlainObject(e)
            ? u.ObjectToXml(e, !0)
            : null;
        }),
        (u.DeserializeXmlToObject = function (e) {
          if (null == e) return null;
          var t;
          try {
            t = new DOMParser().parseFromString(e, 'text/xml');
          } catch (e) {
            t = void 0;
          }
          if (
            null == t ||
            null == t.documentElement ||
            0 < t.getElementsByTagName('parsererror').length
          )
            throw l.utils.newError(
              l.utils.ERR_INVALID_ARGUMENT,
              'Invalid XML string'
            );
          return u.XmlToJson(t);
        }),
        (u.prototype.soapAjax = function (r, e, t) {
          var i = this,
            o = u.SerializeDataToXml(e),
            a =
              '<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/"><s:Body xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema"><' +
              r +
              ' xmlns="' +
              this.mNamespaceUrl +
              '" xmlns:ns1="' +
              this.mNamespaceUrl +
              '">' +
              o +
              '</' +
              r +
              '></s:Body></s:Envelope>',
            n = {
              dataType: 'xml',
              timeout: this.requestTimeout,
              headers: { 'Content-Type': 'text/xml; charset=UTF-8' },
            };
          return (
            Object.assign(n, t),
            l.utils.async
              .ajax('POST', this.mUrl, a, n, function (e, t, o) {
                var r = i.getErrorBodyFromXhr(t, o);
                if (null == r) return e;
                var a = r['S:Fault'].faultstring;
                return (
                  u.LogSoapErrors && l.utils.Log.warn('EAIWS-Error: ' + a),
                  new s(a)
                );
              })
              .then(function (e) {
                var t = i.getBodyFromSoapResponse(e),
                  o = null;
                return null != t && (o = t['ns2:' + r + 'Response'].return), o;
              })
          );
        }),
        (u.ObjectToXml = function (e, t) {
          var o = '';
          if (e instanceof c)
            for (var r in e)
              e.hasOwnProperty(r) &&
                !e._isAttribute(r) &&
                (o += u.PropertyToXml(r, e._getPropertyValue(r), t));
          else
            for (var r in e)
              e.hasOwnProperty(r) && (o += u.PropertyToXml(r, e[r], t));
          return o;
        }),
        (u.PropertyToXml = function (e, t, o) {
          if (null == t) return '';
          var r = '';
          if (l.utils.array.isArray(t)) {
            for (var a = 0; a < t.length; ++a) r += u.PropertyToXml(e, t[a], o);
            return r;
          }
          r += o ? '<' + e + ' xmlns=""' : '<' + e;
          var i = t;
          if (t instanceof c) {
            var n,
              s = t._getClassName();
            for (var p in (null != s && (r += ' xsi:type="ns1:' + s + '"'), t))
              t.hasOwnProperty(p) &&
                (t._isAttribute(p)
                  ? null != (n = t[p]) &&
                    (r +=
                      ' ' +
                      p +
                      '="' +
                      l.utils.string.htmlEscape(n.toString()) +
                      '"')
                  : t._isNodeText(p) && (i = t[p]));
          }
          return (
            (r += '>'),
            null != i &&
              (l.utils.object.isPlainObject(i) || i instanceof c
                ? (r += u.ObjectToXml(i, !1))
                : l.utils.boolean.isBoolean(i)
                ? (r += i ? 'true' : 'false')
                : (r += l.utils.string.htmlEscape(i.toString()))),
            (r += '</' + e + '>')
          );
        }),
        (u.XmlToJson = function (e) {
          if (null == e) return null;
          var t,
            o,
            r = {};
          if (e instanceof Element && 0 < e.attributes.length)
            for (t = 0; t < e.attributes.length; t++) {
              var a = e.attributes.item(t);
              if (null != a) {
                if ('xsi:nil' === a.nodeName && 'true' === a.value) return null;
                r[a.nodeName] = a.value;
              }
            }
          for (t = 0; t < e.childNodes.length; t++)
            switch ((o = e.childNodes[t]).nodeType) {
              case 1:
                var i,
                  n =
                    0 === o.attributes.length && 0 === o.childElementCount
                      ? o.textContent
                      : u.XmlToJson(o),
                  s = o.nodeName;
                r.hasOwnProperty(s)
                  ? ((i = r[s]),
                    Array.isArray(i) || ((i = [i]), (r[s] = i)),
                    i.push(n))
                  : (r[s] = n);
                break;
              case 3:
                r[u.NODE_TEXT_KEY] = o.nodeValue;
            }
          return r;
        }),
        (u.prototype.getBodyFromSoapResponse = function (e) {
          if (null == e || !(e instanceof Node)) return null;
          var t = u.XmlToJson(e);
          return null == t ? null : t['S:Envelope']['S:Body'];
        }),
        (u.prototype.getErrorBodyFromXhr = function (e, t) {
          var o = null,
            o = null != t && t instanceof Node ? t : e.responseXML;
          return this.getBodyFromSoapResponse(o);
        }),
        (u.LogSoapErrors = !1),
        (u.NODE_TEXT_KEY = 'soapNodeText'),
        u);
      function u(e, t, o) {
        (this.mUrl = e), (this.mNamespaceUrl = t), (this.mSessionId = o);
      }
      e.SoapService = t;
      var c =
        ((a.prototype._isAttribute = function (e) {
          return null != this._soapAttributes && this._soapAttributes.has(e);
        }),
        (a.prototype._isNodeText = function (e) {
          return this._soapNodetext === e;
        }),
        (a.prototype._getPropertyValue = function (e) {
          return this[e];
        }),
        (a.prototype._getClassName = function () {}),
        a);
      function a() {}
      (e.SoapRequestData = c),
        (e.soapAttribute = function () {
          return function (e, t) {
            null == e._soapAttributes && (e._soapAttributes = new Set()),
              e._soapAttributes.add(t);
          };
        }),
        (e.soapNodeText = function () {
          return function (e, t) {
            e._soapNodetext = t;
          };
        });
      var i,
        n = (__extends(p, (i = t)), p);
      function p(e, t, o, r) {
        var a = i.call(this, t, o, r) || this;
        return (a.mOwner = e), a;
      }
      e.BaseEaiwsService = n;
    })((l = e.wcf || (e.wcf = {})).eaiws || (l.eaiws = {}));
  })((egr = egr || {})),
  (function (e) {
    var r, a, i, n, t;
    function o(e, t, o) {
      return (
        n.call(
          this,
          e,
          r.utils.string.joinPath(t, 'EAI/Basket'),
          'http://basket.ws.eai.egr/',
          o
        ) || this
      );
    }
    (r = e.wcf || (e.wcf = {})),
      (a = r.eaiws || (r.eaiws = {})),
      (i = a.basket || (a.basket = {})),
      (n = a.BaseEaiwsService),
      __extends(o, n),
      (o.prototype.addBasketColumns = function (e) {
        return this.soapAjax('addBasketColumns', {
          sessionId: this.mSessionId,
          columns: e,
        }).then(function (e) {
          return i.BasketColumn.FromSoapArrayNU(e);
        });
      }),
      (o.prototype.addBasketView = function (e) {
        return this.soapAjax('addBasketView', {
          sessionId: this.mSessionId,
          template: e,
        }).then(function (e) {
          return i.BasketViewConfig.FromSoap(e);
        });
      }),
      (o.prototype.addManualCondition = function (e, t, o, r) {
        return this.soapAjax('addManualCondition', {
          sessionId: this.mSessionId,
          itemIds: e,
          ppName: t,
          condType: o,
          options: r,
        });
      }),
      (o.prototype.addPriceCalculation = function (e) {
        return this.soapAjax('addPriceCalculation', {
          sessionId: this.mSessionId,
          ppName: e,
        });
      }),
      (o.prototype.addToSetArticle = function (e, t) {
        return this.soapAjax('addToSetArticle', {
          sessionId: this.mSessionId,
          itemIds: e,
          opMode: t,
        });
      }),
      (o.prototype.breakUpSetArticle = function (e) {
        return this.soapAjax('breakUpSetArticle', {
          sessionId: this.mSessionId,
          setArtId: e,
        });
      }),
      (o.prototype.changeAlternativePositionState = function (e, t, o, r) {
        return this.soapAjax('changeAlternativePositionState', {
          sessionId: this.mSessionId,
          itemIds: e,
          ppName: t,
          altPos: o,
          options: r,
        });
      }),
      (o.prototype.changeBasketConfig = function (e) {
        return this.soapAjax('changeBasketConfig', {
          sessionId: this.mSessionId,
          basketConfig: e,
        });
      }),
      (o.prototype.changeBasketViewConfig = function (e) {
        return this.soapAjax('changeBasketViewConfig', {
          sessionId: this.mSessionId,
          viewConfig: e,
        });
      }),
      (o.prototype.convertToSetArticle = function (e, t) {
        return this.soapAjax('convertToSetArticle', {
          sessionId: this.mSessionId,
          folderId: null == e ? '' : e,
          opMode: t,
        });
      }),
      (o.prototype.convertToUserArticles = function (e, t) {
        return this.soapAjax('convertToUserArticles', {
          sessionId: this.mSessionId,
          itemIds: e,
          options: t,
        }).then(function (e) {
          return a.SoapService.SoapDataToArrayNU(e);
        });
      }),
      (o.prototype.copy = function (e, t, o, r) {
        return this.soapAjax('copy', {
          sessionId: this.mSessionId,
          itemIds: e,
          opMode: t,
          uri: null == o ? '' : o,
          options: r,
        });
      }),
      (o.prototype.deleteItems = function (e, t) {
        return this.soapAjax('deleteItems', {
          sessionId: this.mSessionId,
          itemIds: e,
          options: t,
        });
      }),
      (o.prototype.getAllChoiceLists = function (e) {
        return this.soapAjax('getAllChoiceLists', {
          sessionId: this.mSessionId,
          itemId: null == e ? '' : e,
        }).then(function (e) {
          return i.ChoiceList.FromSoapArrayNU(e);
        });
      }),
      (o.prototype.getAllItems = function (e, t) {
        return this.soapAjax('getAllItems', {
          sessionId: this.mSessionId,
          itemIds: e,
          options: t,
        }).then(function (e) {
          return i.BasketItem.FromSoapArrayNU(e);
        });
      }),
      (o.prototype.getArticleData = function (e, t) {
        return this.soapAjax('getArticleData', {
          sessionId: this.mSessionId,
          itemId: null == e ? '' : e,
          options: t,
        }).then(function (e) {
          return i.ArticleData.FromSoapNU(e);
        });
      }),
      (o.prototype.getArticleFeatures = function (e, t) {
        return this.soapAjax('getArticleFeatures', {
          sessionId: this.mSessionId,
          itemId: null == e ? '' : e,
          options: t,
        }).then(function (e) {
          return i.ArticleFeature.FromSoapArrayNU(e);
        });
      }),
      (o.prototype.getBasketAppData = function (e, t) {
        return this.soapAjax('getBasketAppData', {
          sessionId: this.mSessionId,
          appKey: null == e ? '' : e,
          paths: t,
        }).then(function (e) {
          return a.SoapService.SoapDataToArrayNU(e);
        });
      }),
      (o.prototype.getBasketColumns = function (e) {
        return this.soapAjax('getBasketColumns', {
          sessionId: this.mSessionId,
          columnIds: e,
        }).then(function (e) {
          return i.BasketColumn.FromSoapArrayNU(e);
        });
      }),
      (o.prototype.getBasketConfig = function () {
        return this.soapAjax('getBasketConfig', {
          sessionId: this.mSessionId,
        }).then(function (e) {
          return i.BasketConfig.FromSoap(e);
        });
      }),
      (o.prototype.getBasketViewConfigs = function (e) {
        return this.soapAjax('getBasketViewConfigs', {
          sessionId: this.mSessionId,
          viewIds: e,
        }).then(function (e) {
          return i.BasketViewConfig.FromSoapArrayNU(e);
        });
      }),
      (o.prototype.getChoiceList = function (e, t, o) {
        return this.soapAjax('getChoiceList', {
          sessionId: this.mSessionId,
          itemId: null == e ? '' : e,
          propClass: null == t ? '' : t,
          propName: null == o ? '' : o,
        }).then(function (e) {
          return i.PropertyValue.FromSoapArrayNU(e);
        });
      }),
      (o.prototype.getConditionTypes = function (e, t, o) {
        return this.soapAjax('getConditionTypes', {
          sessionId: this.mSessionId,
          active: e,
          ppName: t,
          names: o,
        }).then(function (e) {
          return i.ConditionType.FromSoapArrayNU(e);
        });
      }),
      (o.prototype.getCurrency = function () {
        return this.soapAjax('getCurrency', { sessionId: this.mSessionId });
      }),
      (o.prototype.getCurrentTaxScheme = function () {
        return this.soapAjax('getCurrentTaxScheme', {
          sessionId: this.mSessionId,
        });
      }),
      (o.prototype.getExchangeRates = function (e) {
        return this.soapAjax('getExchangeRates', {
          sessionId: this.mSessionId,
          currencies: e,
        }).then(function (e) {
          return i.ExchangeRate.FromSoapArrayNU(e);
        });
      }),
      (o.prototype.getExportedGeometry = function (e, t, o) {
        return this.soapAjax(
          'getExportedGeometry',
          {
            sessionId: this.mSessionId,
            itemId: null == e ? '' : e,
            options: t,
          },
          null != o ? { timeout: o } : void 0
        );
      }),
      (o.prototype.getGeneratedImage = function (e, t) {
        return this.soapAjax('getGeneratedImage', {
          sessionId: this.mSessionId,
          itemId: null == e ? '' : e,
          options: t,
        });
      }),
      (o.prototype.getImages = function (e, t) {
        return this.soapAjax('getImages', {
          sessionId: this.mSessionId,
          itemId: e,
          options: t,
        }).then(function (e) {
          return i.ImageInfo.FromSoapArrayNU(e);
        });
      }),
      (o.prototype.getItemAppData = function (e, t, o) {
        return this.soapAjax('getItemAppData', {
          sessionId: this.mSessionId,
          itemId: null == e ? '' : e,
          appKey: null == t ? '' : t,
          paths: o,
        }).then(function (e) {
          return a.SoapService.SoapDataToArrayNU(e);
        });
      }),
      (o.prototype.getItemFields = function (e, t, o) {
        return this.soapAjax('getItemFields', {
          sessionId: this.mSessionId,
          itemIds: e,
          columnIds: t,
          options: o,
        }).then(function (e) {
          return i.ItemField.FromSoapArrayNU(e);
        });
      }),
      (o.prototype.getItemProperties = function (e, t) {
        return this.soapAjax('getItemProperties', {
          sessionId: this.mSessionId,
          itemIds: e,
          options: t,
        }).then(function (e) {
          return i.ItemProperties.FromSoapArrayNU(e);
        });
      }),
      (o.prototype.getLanguages = function () {
        var t = this;
        return null != this.mLanguages
          ? Promise.resolve(this.mLanguages)
          : this.soapAjax('getLanguages', { sessionId: this.mSessionId }).then(
              function (e) {
                return (
                  (t.mLanguages = a.SoapService.SoapDataToArrayNU(e)),
                  t.mLanguages
                );
              }
            );
      }),
      (o.prototype.getPriceCalculationSheet = function (e, t, o) {
        return this.soapAjax('getPriceCalculationSheet', {
          sessionId: this.mSessionId,
          itemIds: e,
          ppName: t,
          options: o,
        }).then(function (e) {
          return i.CalculationSheet.FromSoapNU(e);
        });
      }),
      (o.prototype.getPriceCalculationSheets = function (e, t, o) {
        return this.soapAjax('getPriceCalculationSheets', {
          sessionId: this.mSessionId,
          itemIds: e,
          ppName: t,
          options: o,
        }).then(function (e) {
          return i.ItemCalculationSheet.FromSoapArrayNU(e);
        });
      }),
      (o.prototype.getPricingProcedure = function (e, t) {
        return this.soapAjax('getPricingProcedure', {
          sessionId: this.mSessionId,
          active: e,
          name: t,
        }).then(function (e) {
          return i.PricingProcedure.FromSoapNU(e);
        });
      }),
      (o.prototype.getReferenceCurrency = function () {
        return this.soapAjax('getReferenceCurrency', {
          sessionId: this.mSessionId,
        });
      }),
      (o.prototype.getTaxInformation = function (e) {
        return this.soapAjax('getTaxInformation', {
          sessionId: this.mSessionId,
          itemId: e,
        }).then(function (e) {
          return i.TaxInfo.FromSoapArrayNU(e);
        });
      }),
      (o.prototype.getTaxScheme = function (e, t) {
        return this.soapAjax('getTaxScheme', {
          sessionId: this.mSessionId,
          active: e,
          schemeId: t,
        }).then(function (e) {
          return i.TaxScheme.FromSoapNU(e);
        });
      }),
      (o.prototype.getTopFolderId = function (e) {
        return this.soapAjax('getTopFolderId', {
          sessionId: this.mSessionId,
          viewId: e,
        });
      }),
      (o.prototype.insertFolder = function (e, t, o) {
        return this.soapAjax('insertFolder', {
          sessionId: this.mSessionId,
          fatherId: null == e ? '' : e,
          beforeId: null == t ? '' : t,
          name: o,
        });
      }),
      (o.prototype.insertTextItem = function (e, t, o) {
        return this.soapAjax('insertTextItem', {
          sessionId: this.mSessionId,
          fatherId: null == e ? '' : e,
          beforeId: null == t ? '' : t,
          text: o,
        });
      }),
      (o.prototype.insertUserArticle = function (e, t, o) {
        return this.soapAjax('insertUserArticle', {
          sessionId: this.mSessionId,
          fatherId: null == e ? '' : e,
          beforeId: null == t ? '' : t,
          shortText: o,
        });
      }),
      (o.prototype.insertOFMLArticle = function (e, t, o, r) {
        return this.soapAjax('insertOFMLArticle', {
          sessionId: this.mSessionId,
          fatherId: null == e ? '' : e,
          beforeId: null == t ? '' : t,
          insertInfo: o,
          options: r,
        });
      }),
      (o.prototype.listPricingProcedures = function (e) {
        return this.soapAjax('listPricingProcedures', {
          sessionId: this.mSessionId,
          active: e,
        }).then(function (e) {
          return i.PricingProcedureDescription.FromSoapArrayNU(e);
        });
      }),
      (o.prototype.listTaxSchemes = function (e, t) {
        return this.soapAjax('listTaxSchemes', {
          sessionId: this.mSessionId,
          active: e,
          country: t,
        }).then(function (e) {
          return i.TaxSchemeDescription.FromSoapArrayNU(e);
        });
      }),
      (o.prototype.mergeBasketArticles = function (e, t) {
        return this.soapAjax('mergeBasketArticles', {
          sessionId: this.mSessionId,
          itemIds: e,
          options: t,
        }).then(function (e) {
          return i.MergeResult.FromSoapNU(e);
        });
      }),
      (o.prototype.moveItems = function (e, t) {
        return this.soapAjax('moveItems', {
          sessionId: this.mSessionId,
          itemIds: e,
          direction: t,
        });
      }),
      (o.prototype.oapGetActionData = function (e, t, o) {
        return this.soapAjax('oapGetActionData', {
          sessionId: this.mSessionId,
          itemId: e,
          actionId: t,
          dpr: o,
        }).then(function (e) {
          return i.OAPAction.FromSoap(e);
        });
      }),
      (o.prototype.oapGetInteractors = function (e, t, o) {
        return this.soapAjax('oapGetInteractors', {
          sessionId: this.mSessionId,
          itemId: e,
          interactorIds: t,
          dpr: o,
        }).then(function (e) {
          return i.OAPInteractor.FromSoapArrayNU(e);
        });
      }),
      (o.prototype.oapProcessActions = function (e, t, o) {
        return this.soapAjax('oapProcessActions', {
          sessionId: this.mSessionId,
          actionIds: e,
          exec: t,
          context: o,
        }).then(function (e) {
          return i.OAPActionResult.FromSoapArrayNU(e);
        });
      }),
      (o.prototype.oapSetClientCapabilities = function (e) {
        return this.soapAjax('oapSetClientCapabilities', {
          sessionId: this.mSessionId,
          capabilities: e,
        });
      }),
      (o.prototype.paste = function (e, t, o, r) {
        return this.soapAjax('paste', {
          sessionId: this.mSessionId,
          fatherId: null == e ? '' : e,
          beforeId: null == t ? '' : t,
          uri: o,
          options: r,
        }).then(function (e) {
          return a.SoapService.SoapDataToArrayNU(e);
        });
      }),
      (o.prototype.pasteContainer = function (e, t, o, r) {
        return this.soapAjax('pasteContainer', {
          sessionId: this.mSessionId,
          fatherId: null == e ? '' : e,
          beforeId: null == t ? '' : t,
          uri: o,
          options: r,
        }).then(function (e) {
          return i.PasteContainerResult.FromSoap(e);
        });
      }),
      (o.prototype.relocateItems = function (e, t, o, r) {
        return this.soapAjax('relocateItems', {
          sessionId: this.mSessionId,
          fatherId: null == e ? '' : e,
          beforeId: null == t ? '' : t,
          itemIds: o,
          options: r,
        });
      }),
      (o.prototype.removeBasketColumns = function (e) {
        return this.soapAjax('removeBasketColumns', {
          sessionId: this.mSessionId,
          columnIds: e,
        });
      }),
      (o.prototype.removeBasketViews = function (e) {
        return this.soapAjax('removeBasketViews', {
          sessionId: this.mSessionId,
          viewIds: e,
        });
      }),
      (o.prototype.removeCondition = function (e, t, o, r, a) {
        return this.soapAjax('removeCondition', {
          sessionId: this.mSessionId,
          itemIds: e,
          ppName: t,
          condType: o,
          counter: r,
          options: a,
        });
      }),
      (o.prototype.removeFromSetArticle = function (e, t) {
        return this.soapAjax('removeFromSetArticle', {
          sessionId: this.mSessionId,
          itemIds: e,
          opMode: t,
        });
      }),
      (o.prototype.resetConditionAmount = function (e, t, o, r, a) {
        return this.soapAjax('resetConditionAmount', {
          sessionId: this.mSessionId,
          itemIds: e,
          ppName: t,
          condType: o,
          counter: r,
          options: a,
        });
      }),
      (o.prototype.resetItemFields = function (e, t, o, r) {
        return this.soapAjax('resetItemFields', {
          sessionId: this.mSessionId,
          itemIds: e,
          columnId: t,
          data: o,
          options: r,
        });
      }),
      (o.prototype.resetQuantityRelation = function (e, t, o, r, a) {
        return this.soapAjax('resetQuantityRelation', {
          sessionId: this.mSessionId,
          itemIds: e,
          ppName: t,
          condType: o,
          counter: r,
          options: a,
        });
      }),
      (o.prototype.resetTaxConfiguration = function () {
        return this.soapAjax('resetTaxConfiguration', {
          sessionId: this.mSessionId,
        });
      }),
      (o.prototype.resetTaxScheme = function (e) {
        return this.soapAjax('resetTaxScheme', {
          sessionId: this.mSessionId,
          schemeId: e,
        });
      }),
      (o.prototype.resetTaxRate = function (e, t, o) {
        return this.soapAjax('resetTaxRate', {
          sessionId: this.mSessionId,
          schemeId: e,
          typeId: t,
          categoryId: o,
        });
      }),
      (o.prototype.selectCurrentTaxScheme = function (e) {
        return this.soapAjax('selectCurrentTaxScheme', {
          sessionId: this.mSessionId,
          schemeId: e,
        });
      }),
      (o.prototype.setBasketAppData = function (e, t) {
        return this.soapAjax('setBasketAppData', {
          sessionId: this.mSessionId,
          appKey: null == e ? '' : e,
          data: t,
        });
      }),
      (o.prototype.setBasketColumnProperties = function (e) {
        return this.soapAjax('setBasketColumnProperties', {
          sessionId: this.mSessionId,
          columns: e,
        });
      }),
      (o.prototype.setConditionAmount = function (e, t, o, r, a, i, n) {
        return this.soapAjax('setConditionAmount', {
          sessionId: this.mSessionId,
          itemIds: e,
          ppName: t,
          condType: o,
          counter: r,
          amount: a,
          currency: i,
          options: n,
        });
      }),
      (o.prototype.setConditionDescription = function (e, t, o, r) {
        return this.soapAjax('setConditionDescription', {
          sessionId: this.mSessionId,
          ppName: e,
          condType: t,
          lang: o,
          description: r,
        });
      }),
      (o.prototype.setCurrency = function (e) {
        return this.soapAjax('setCurrency', {
          sessionId: this.mSessionId,
          currency: null == e ? '' : e,
        });
      }),
      (o.prototype.setExchangeRates = function (e) {
        return this.soapAjax('setExchangeRates', {
          sessionId: this.mSessionId,
          exchangeRates: e,
        });
      }),
      (o.prototype.setItemAppData = function (e, t, o) {
        return this.soapAjax('setItemAppData', {
          sessionId: this.mSessionId,
          itemId: null == e ? '' : e,
          appKey: null == t ? '' : t,
          data: o,
        });
      }),
      (o.prototype.setItemFields = function (e) {
        return this.soapAjax('setItemFields', {
          sessionId: this.mSessionId,
          fields: e,
        });
      }),
      (o.prototype.setItemProperties = function (e, t) {
        return this.soapAjax('setItemProperties', {
          sessionId: this.mSessionId,
          itemId: null == e ? '' : e,
          properties: null == t ? new i.ItemProperties() : t,
        });
      }),
      (o.prototype.setLanguages = function (e) {
        var t = this;
        return this.soapAjax('setLanguages', {
          sessionId: this.mSessionId,
          languages: e,
        }).then(function () {
          (t.mLanguages = void 0),
            t.mOwner.eventBasketLanguagesChanged.trigger();
        });
      }),
      (o.prototype.setPropertyValue = function (e, t, o, r) {
        return this.soapAjax('setPropertyValue', {
          sessionId: this.mSessionId,
          itemId: e,
          propClass: t,
          propName: o,
          value: null == r ? '' : r,
        });
      }),
      (o.prototype.setQuantityRelation = function (e, t, o, r, a, i, n) {
        return this.soapAjax('setQuantityRelation', {
          sessionId: this.mSessionId,
          itemIds: e,
          ppName: t,
          condType: o,
          counter: r,
          quantity: a,
          unit: i,
          options: n,
        });
      }),
      (o.prototype.setTaxInformation = function (e, t, o) {
        return this.soapAjax('setTaxInformation', {
          sessionId: this.mSessionId,
          itemId: e,
          taxType: t,
          taxCategory: o,
        });
      }),
      (o.prototype.setTaxRate = function (e, t, o, r) {
        return this.soapAjax('setTaxRate', {
          sessionId: this.mSessionId,
          schemeId: e,
          typeId: t,
          categoryId: o,
          rate: r,
        });
      }),
      (o.prototype.tmGetTable = function (e, t) {
        return this.soapAjax('tmGetTable', {
          sessionId: this.mSessionId,
          viewId: e,
          itemId: t,
        }).then(function (e) {
          return i.TMTable.FromSoap(e);
        });
      }),
      (o.prototype.tmGetText = function (e, t, o) {
        return this.soapAjax('tmGetText', {
          sessionId: this.mSessionId,
          viewId: e,
          itemId: t,
          allLanguages: o,
        }).then(function (e) {
          return i.TMRow.FromSoapArrayNU(e);
        });
      }),
      (o.prototype.tmSetText = function (e, t, o, r, a) {
        return this.soapAjax('tmSetText', {
          sessionId: this.mSessionId,
          viewId: e,
          itemId: t,
          textId: o,
          lang: r,
          text: a,
        });
      }),
      (o.prototype.tmSetTextVisibility = function (e, t, o, r) {
        return this.soapAjax('tmSetTextVisibility', {
          sessionId: this.mSessionId,
          viewId: e,
          itemId: t,
          textId: o,
          visible: r,
        });
      }),
      (o.prototype.updateBasketArticles = function (e, t, o) {
        return this.soapAjax('updateBasketArticles', {
          sessionId: this.mSessionId,
          itemIds: e,
          catalogIds: t,
          options: o,
        }).then(function (e) {
          return i.UpdateBasketArticleResult.FromSoapArrayNU(e);
        });
      }),
      (o.prototype._clearCache = function () {
        this.mLanguages = void 0;
      }),
      (t = o),
      (i.BasketService = t);
  })((egr = egr || {})),
  (function (e) {
    var sr, pr;
    (sr = e.wcf || (e.wcf = {})),
      (function (e) {
        var t,
          o =
            ((t = pr.SoapRequestData),
            __extends(r, t),
            (r.FromSoapArray = function (e) {
              return pr.SoapService.SoapDataToArray(e, r.FromSoapNU);
            }),
            (r.FromSoap = function (e) {
              if (null != e) {
                var t = new r();
                return (
                  (t.catalogId = e.catalogId),
                  (t.manufacturerId = e.manufacturerId),
                  (t.manufacturerName = e.manufacturerName),
                  (t.seriesId = e.seriesId),
                  (t.seriesName = e.seriesName),
                  (t.manufacturer = e.manufacturer),
                  (t.program = e.program),
                  (t.distributionRegion = e.distributionRegion),
                  (t.baseArticleNumber = e.baseArticleNumber),
                  (t.finalArticleNumber = e.finalArticleNumber),
                  (t.variantCode = e.variantCode),
                  (t.ofmlVariantCode = e.ofmlVariantCode),
                  (t.useFinalArticleNumber = pr.SoapService.SoapDataToBool(
                    e.useFinalArticleNumber
                  )),
                  (t.shortText = e.shortText),
                  (t.longText = e.longText),
                  (t.featureText = e.featureText),
                  (t.descriptionMode = e.descriptionMode),
                  (t.currency = e.currency),
                  (t.purchasePrice = pr.SoapService.SoapDataToFloat(
                    e.purchasePrice
                  )),
                  (t.salesPrice = pr.SoapService.SoapDataToFloat(e.salesPrice)),
                  (t.quantity = pr.SoapService.SoapDataToFloat(e.quantity)),
                  (t.alternativePosition = pr.SoapService.SoapDataToBool(
                    e.alternativePosition
                  )),
                  (t.excludedCalculations = pr.SoapService.SoapDataToArray(
                    e.excludedCalculations
                  )),
                  (t.inconsistencyFlag = pr.SoapService.SoapDataToBool(
                    e.inconsistencyFlag
                  )),
                  (t.inconsistencyReason = pr.SoapService.SoapDataToArray(
                    e.inconsistencyReason
                  )),
                  (t.packagingInfo = Ne.FromSoap(e.packagingInfo)),
                  (t.ofmlUpdateState = e.ofmlUpdateState),
                  (t.geometryId = e.geometryId),
                  (t.subArticles = r.FromSoapArray(e.subArticles)),
                  (t.priceInfo = No.FromSoap(e.priceInfo)),
                  t
                );
              }
            }),
            (r.FromSoapNU = function (e) {
              if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
              return r.FromSoap(e);
            }),
            r);
        function r() {
          return (null !== t && t.apply(this, arguments)) || this;
        }
        e.ArticleProperties = o;
        var a,
          i =
            ((a = pr.SoapRequestData),
            __extends(n, a),
            (n.FromSoapArrayNU = function (e) {
              return pr.SoapService.SoapDataToArrayNU(e, n.FromSoapNU);
            }),
            (n.FromSoap = function (e) {
              if (null != e) {
                var t = new n();
                return (
                  (t.name = e.name),
                  (t.title = e.title),
                  (t.defaultValue = e.defaultValue),
                  (t.id = e.id),
                  (t.type = e.type),
                  (t.itemAttrId = e.itemAttrId),
                  (t.removable = pr.SoapService.SoapDataToBool(e.removable)),
                  (t.editable = pr.SoapService.SoapDataToBool(e.editable)),
                  (t.defaultColumn = e.defaultColumn),
                  (t.minWidth = pr.SoapService.SoapDataToFloat(e.minWidth)),
                  (t.weight = pr.SoapService.SoapDataToInt(e.weight)),
                  (t.readOnly = pr.SoapService.SoapDataToBool(e.readOnly)),
                  t
                );
              }
            }),
            (n.FromSoapNU = function (e) {
              if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
              return n.FromSoap(e);
            }),
            __decorate([pr.soapAttribute()], n.prototype, 'id', void 0),
            __decorate([pr.soapAttribute()], n.prototype, 'type', void 0),
            __decorate([pr.soapAttribute()], n.prototype, 'itemAttrId', void 0),
            __decorate([pr.soapAttribute()], n.prototype, 'removable', void 0),
            __decorate([pr.soapAttribute()], n.prototype, 'editable', void 0),
            __decorate(
              [pr.soapAttribute()],
              n.prototype,
              'defaultColumn',
              void 0
            ),
            __decorate([pr.soapAttribute()], n.prototype, 'minWidth', void 0),
            __decorate([pr.soapAttribute()], n.prototype, 'weight', void 0),
            __decorate([pr.soapAttribute()], n.prototype, 'readOnly', void 0),
            n);
        function n() {
          var e = a.call(this) || this;
          return (e.id = ''), e;
        }
        e.BasketColumn = i;
        var s,
          p =
            ((s = pr.SoapRequestData),
            __extends(u, s),
            (u.FromSoap = function (e) {
              if (null != e) {
                var t = new u();
                return (
                  (t.viewIds = pr.SoapService.SoapDataToArray(e.viewIds)),
                  (t.columnIds = pr.SoapService.SoapDataToArray(e.columnIds)),
                  (t.defaultView = e.defaultView),
                  (t.columnsEditable = pr.SoapService.SoapDataToBool(
                    e.columnsEditable
                  )),
                  (t.currency = e.currency),
                  (t.currencyEditable = pr.SoapService.SoapDataToBool(
                    e.currencyEditable
                  )),
                  t
                );
              }
            }),
            __decorate(
              [pr.soapAttribute()],
              u.prototype,
              'defaultView',
              void 0
            ),
            __decorate(
              [pr.soapAttribute()],
              u.prototype,
              'columnsEditable',
              void 0
            ),
            __decorate([pr.soapAttribute()], u.prototype, 'currency', void 0),
            __decorate(
              [pr.soapAttribute()],
              u.prototype,
              'currencyEditable',
              void 0
            ),
            u);
        function u() {
          return (null !== s && s.apply(this, arguments)) || this;
        }
        e.BasketConfig = p;
        var c,
          l =
            ((c = pr.SoapRequestData),
            __extends(d, c),
            (d.FromSoapArrayNU = function (e) {
              return pr.SoapService.SoapDataToArrayNU(e, d.FromSoapNU);
            }),
            (d.FromSoap = function (e) {
              if (null != e) {
                var t = new d();
                return (
                  (t.name = e.name),
                  (t.visibleColumns = pr.SoapService.SoapDataToArray(
                    e.visibleColumns
                  )),
                  (t.columnWidths = S.FromSoapArray(e.columnWidths)),
                  (t.viewId = e.viewId),
                  (t.removable = pr.SoapService.SoapDataToBool(e.removable)),
                  (t.editable = pr.SoapService.SoapDataToBool(e.editable)),
                  (t.displayMode = e.displayMode),
                  (t.expandGroups = pr.SoapService.SoapDataToBool(
                    e.expandGroups
                  )),
                  (t.expandPlanningFolders = pr.SoapService.SoapDataToBool(
                    e.expandPlanningFolders
                  )),
                  (t.expandBasketFolders = pr.SoapService.SoapDataToBool(
                    e.expandBasketFolders
                  )),
                  (t.expandPartialPlannings = pr.SoapService.SoapDataToBool(
                    e.expandPartialPlannings
                  )),
                  (t.expandAggregates = pr.SoapService.SoapDataToBool(
                    e.expandAggregates
                  )),
                  (t.mergeMode = e.mergeMode),
                  (t.autoColumnWidth = pr.SoapService.SoapDataToBool(
                    e.autoColumnWidth
                  )),
                  (t.hiddenDiscounts = pr.SoapService.SoapDataToBool(
                    e.hiddenDiscounts
                  )),
                  (t.setArticleMode = e.setArticleMode),
                  t
                );
              }
            }),
            (d.FromSoapNU = function (e) {
              if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
              return d.FromSoap(e);
            }),
            __decorate([pr.soapAttribute()], d.prototype, 'viewId', void 0),
            __decorate([pr.soapAttribute()], d.prototype, 'removable', void 0),
            __decorate([pr.soapAttribute()], d.prototype, 'editable', void 0),
            __decorate(
              [pr.soapAttribute()],
              d.prototype,
              'displayMode',
              void 0
            ),
            __decorate(
              [pr.soapAttribute()],
              d.prototype,
              'expandGroups',
              void 0
            ),
            __decorate(
              [pr.soapAttribute()],
              d.prototype,
              'expandPlanningFolders',
              void 0
            ),
            __decorate(
              [pr.soapAttribute()],
              d.prototype,
              'expandBasketFolders',
              void 0
            ),
            __decorate(
              [pr.soapAttribute()],
              d.prototype,
              'expandPartialPlannings',
              void 0
            ),
            __decorate(
              [pr.soapAttribute()],
              d.prototype,
              'expandAggregates',
              void 0
            ),
            __decorate([pr.soapAttribute()], d.prototype, 'mergeMode', void 0),
            __decorate(
              [pr.soapAttribute()],
              d.prototype,
              'autoColumnWidth',
              void 0
            ),
            __decorate(
              [pr.soapAttribute()],
              d.prototype,
              'hiddenDiscounts',
              void 0
            ),
            __decorate(
              [pr.soapAttribute()],
              d.prototype,
              'setArticleMode',
              void 0
            ),
            d);
        function d() {
          var e = c.call(this) || this;
          return (e.viewId = ''), e;
        }
        e.BasketViewConfig = l;
        var m,
          S =
            ((m = pr.SoapRequestData),
            __extends(y, m),
            (y.FromSoapArray = function (e) {
              return pr.SoapService.SoapDataToArray(e, y.FromSoapNU);
            }),
            (y.FromSoapNU = function (e) {
              if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
              var t = new y();
              return (
                (t.columnId = e.columnId),
                (t.width = pr.SoapService.SoapDataToInt(e.value)),
                t
              );
            }),
            __decorate([pr.soapAttribute()], y.prototype, 'columnId', void 0),
            __decorate([pr.soapAttribute()], y.prototype, 'width', void 0),
            y);
        function y() {
          var e = m.call(this) || this;
          return (e.columnId = ''), (e.width = 0), e;
        }
        e.ColumnWidth = S;
        var f,
          h =
            ((f = pr.SoapRequestData),
            __extends(v, f),
            (v.FromSoapArray = function (e) {
              return pr.SoapService.SoapDataToArray(e, v.FromSoapNU);
            }),
            (v.FromSoap = function (e) {
              if (null != e) {
                var t = new v();
                return (
                  (t.enabled = pr.SoapService.SoapDataToBool(e.enabled)),
                  (t.position = Xe.FromSoap(e.position)),
                  (t.rotation = Ee.FromSoap(e.rotation)),
                  (t.scale = Xe.FromSoap(e.scale)),
                  (t.geometry = e.geometry),
                  (t.itemId = e.itemId),
                  t
                );
              }
            }),
            (v.FromSoapNU = function (e) {
              if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
              return v.FromSoap(e);
            }),
            __decorate([pr.soapAttribute()], v.prototype, 'itemId', void 0),
            v);
        function v() {
          return (null !== f && f.apply(this, arguments)) || this;
        }
        e.ComposableGeometryProperties = h;
        var A,
          I =
            ((A = pr.SoapRequestData),
            __extends(_, A),
            __decorate([pr.soapAttribute()], _.prototype, 'encoding', void 0),
            __decorate([pr.soapAttribute()], _.prototype, 'suffix', void 0),
            __decorate([pr.soapAttribute()], _.prototype, 'overwrite', void 0),
            __decorate([pr.soapAttribute()], _.prototype, 'cut', void 0),
            _);
        function _() {
          return (null !== A && A.apply(this, arguments)) || this;
        }
        e.CopyOptions = I;
        var g,
          N =
            ((g = pr.SoapRequestData),
            __extends(b, g),
            (b.FromSoapArrayNU = function (e) {
              return pr.SoapService.SoapDataToArrayNU(e, b.FromSoapNU);
            }),
            (b.FromSoapNU = function (e) {
              if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
              var t = new b();
              return (
                (t.currency = e.currency),
                (t.rate = pr.SoapService.SoapDataToFloat(e.rate)),
                t
              );
            }),
            __decorate([pr.soapAttribute()], b.prototype, 'currency', void 0),
            __decorate([pr.soapAttribute()], b.prototype, 'rate', void 0),
            b);
        function b() {
          var e = g.call(this) || this;
          return (e.currency = ''), (e.rate = 0), e;
        }
        e.ExchangeRate = N;
        var T,
          D =
            ((T = pr.SoapRequestData),
            __extends(x, T),
            (x.FromSoap = function (e) {
              if (null != e) {
                var t = new x();
                return (
                  (t.name = e.name),
                  (t.showSubTotal = pr.SoapService.SoapDataToBool(
                    e.showSubTotal
                  )),
                  t
                );
              }
            }),
            x);
        function x() {
          return (null !== T && T.apply(this, arguments)) || this;
        }
        e.FolderProperties = D;
        var F,
          U = ((F = pr.SoapRequestData), __extends(w, F), w);
        function w() {
          return (null !== F && F.apply(this, arguments)) || this;
        }
        e.GetArticleDataOptions = U;
        var P,
          R = ((P = pr.SoapRequestData), __extends(j, P), j);
        function j() {
          return (null !== P && P.apply(this, arguments)) || this;
        }
        e.GetArticleFeaturesOptions = R;
        var C,
          E = ((C = pr.SoapRequestData), __extends(L, C), L);
        function L() {
          return (null !== C && C.apply(this, arguments)) || this;
        }
        e.InsertArticleOptions = E;
        var O,
          V = ((O = pr.SoapRequestData), __extends(B, O), B);
        function B() {
          var e = O.call(this) || this;
          return (e.baseArticleNumber = ''), e;
        }
        e.InsertInfo = V;
        var k,
          M =
            ((k = pr.SoapRequestData),
            __extends(G, k),
            (G.FromSoapArrayNU = function (e) {
              return pr.SoapService.SoapDataToArrayNU(e, G.FromSoapNU);
            }),
            (G.FromSoapNU = function (e) {
              if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
              var t = new G();
              return (
                (t.itemId = e.itemId),
                (t.itemType = e.itemType),
                (t.visible = pr.SoapService.SoapDataToBool(e.visible)),
                (t.expanded = pr.SoapService.SoapDataToBool(e.expanded)),
                (t.label = e.label),
                (t.setArticleId = e.setArticleId),
                (t.tmRows = Jo.FromSoapArray(e.tmRows)),
                (t.tmDescription = e.tmDescription),
                (t.composableGeometry = h.FromSoap(e.composableGeometry)),
                (t.composableGeometries = h.FromSoapArray(
                  e.composableGeometries
                )),
                (t.folder = D.FromSoap(e.folder)),
                (t.article = o.FromSoap(e.article)),
                (t.setArticle = Ve.FromSoap(e.setArticle)),
                (t.textItem = Me.FromSoap(e.textItem)),
                (t.positionNumber = e.positionNumber),
                t
              );
            }),
            __decorate(
              [pr.soapAttribute()],
              G.prototype,
              'positionNumber',
              void 0
            ),
            G);
        function G() {
          return (null !== k && k.apply(this, arguments)) || this;
        }
        e.ItemProperties = M;
        var q,
          X =
            ((q = pr.SoapRequestData),
            __extends(z, q),
            __decorate(
              [pr.soapAttribute()],
              z.prototype,
              'wholeComposite',
              void 0
            ),
            __decorate([pr.soapAttribute()], z.prototype, 'subItems', void 0),
            __decorate(
              [pr.soapAttribute()],
              z.prototype,
              'parentItems',
              void 0
            ),
            __decorate([pr.soapAttribute()], z.prototype, 'viewId', void 0),
            z);
        function z() {
          return (null !== q && q.apply(this, arguments)) || this;
        }
        e.ItemSelectionOptions = X;
        var K,
          W =
            (__extends(H, (K = X)),
            __decorate(
              [pr.soapAttribute()],
              H.prototype,
              'subArticles',
              void 0
            ),
            H);
        function H() {
          return (null !== K && K.apply(this, arguments)) || this;
        }
        e.DeleteItemsOptions = W;
        var Q,
          Y =
            (__extends(J, (Q = X)),
            __decorate(
              [pr.soapAttribute()],
              J.prototype,
              'setArticleIds',
              void 0
            ),
            __decorate(
              [pr.soapAttribute()],
              J.prototype,
              'geometryIds',
              void 0
            ),
            __decorate(
              [pr.soapAttribute()],
              J.prototype,
              'positionNumbers',
              void 0
            ),
            __decorate(
              [pr.soapAttribute()],
              J.prototype,
              'basketItems',
              void 0
            ),
            J);
        function J() {
          return (null !== Q && Q.apply(this, arguments)) || this;
        }
        e.GetAllItemsOptions = Y;
        var Z,
          $ =
            (__extends(ee, (Z = X)),
            __decorate([pr.soapAttribute()], ee.prototype, 'useCache', void 0),
            __decorate([pr.soapAttribute()], ee.prototype, 'generate', void 0),
            __decorate([pr.soapAttribute()], ee.prototype, 'itemIds', void 0),
            __decorate(
              [pr.soapAttribute()],
              ee.prototype,
              'attributes',
              void 0
            ),
            ee);
        function ee() {
          return (null !== Z && Z.apply(this, arguments)) || this;
        }
        e.GetImagesOptions = $;
        var te,
          oe =
            (__extends(re, (te = X)),
            __decorate(
              [pr.soapAttribute()],
              re.prototype,
              'useDefault',
              void 0
            ),
            __decorate(
              [pr.soapAttribute()],
              re.prototype,
              'expandVariables',
              void 0
            ),
            __decorate(
              [pr.soapAttribute()],
              re.prototype,
              'resolveURI',
              void 0
            ),
            __decorate(
              [pr.soapAttribute()],
              re.prototype,
              'useImageCache',
              void 0
            ),
            __decorate(
              [pr.soapAttribute()],
              re.prototype,
              'generateImages',
              void 0
            ),
            re);
        function re() {
          return (null !== te && te.apply(this, arguments)) || this;
        }
        e.GetItemFieldsOptions = oe;
        var ae,
          ie =
            (__extends(ne, (ae = X)),
            __decorate([pr.soapAttribute()], ne.prototype, 'priceInfo', void 0),
            __decorate(
              [pr.soapAttribute()],
              ne.prototype,
              'pricingProcedureName',
              void 0
            ),
            __decorate(
              [pr.soapAttribute()],
              ne.prototype,
              'positionNumbers',
              void 0
            ),
            ne);
        function ne() {
          return (null !== ae && ae.apply(this, arguments)) || this;
        }
        e.GetItemPropertiesOptions = ie;
        var se,
          pe =
            (__extends(ue, (se = X)),
            __decorate(
              [pr.soapAttribute()],
              ue.prototype,
              'sumUpComposite',
              void 0
            ),
            __decorate(
              [pr.soapAttribute()],
              ue.prototype,
              'itemCondAmountPerUnit',
              void 0
            ),
            __decorate(
              [pr.soapAttribute()],
              ue.prototype,
              'headerCondAmountPerUnit',
              void 0
            ),
            ue);
        function ue() {
          return (null !== se && se.apply(this, arguments)) || this;
        }
        e.GetPriceCalculationSheetOptions = pe;
        var ce,
          le =
            ((ce = pr.SoapRequestData),
            __extends(de, ce),
            (de.FromSoapArrayNU = function (e) {
              return pr.SoapService.SoapDataToArrayNU(e, de.FromSoapNU);
            }),
            (de.FromSoapNU = function (e) {
              if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
              var t = new de();
              return (
                (t.data = e.data),
                (t.itemId = e.itemId),
                (t.columnId = e.columnId),
                t
              );
            }),
            __decorate([pr.soapAttribute()], de.prototype, 'itemId', void 0),
            __decorate([pr.soapAttribute()], de.prototype, 'columnId', void 0),
            de);
        function de() {
          var e = ce.call(this) || this;
          return (e.data = ''), (e.itemId = ''), (e.columnId = ''), e;
        }
        e.ItemField = le;
        var me,
          Se =
            (__extends(ye, (me = X)),
            __decorate([pr.soapAttribute()], ye.prototype, 'update', void 0),
            __decorate([pr.soapAttribute()], ye.prototype, 'migrate', void 0),
            __decorate(
              [pr.soapAttribute()],
              ye.prototype,
              'recalculate',
              void 0
            ),
            ye);
        function ye() {
          return (null !== me && me.apply(this, arguments)) || this;
        }
        e.UpdateBasketArticlesOptions = Se;
        var fe,
          he =
            ((fe = pr.SoapRequestData),
            __extends(ve, fe),
            __decorate([pr.soapAttribute()], ve.prototype, 'self', void 0),
            __decorate(
              [pr.soapAttribute()],
              ve.prototype,
              'interactor',
              void 0
            ),
            __decorate([pr.soapAttribute()], ve.prototype, 'dpr', void 0),
            ve);
        function ve() {
          var e = fe.call(this) || this;
          return (e.self = ''), e;
        }
        e.OAPActionContext = he;
        var Ae,
          Ie =
            ((Ae = pr.SoapRequestData),
            __extends(_e, Ae),
            __decorate(
              [pr.soapAttribute()],
              _e.prototype,
              'subPositions',
              void 0
            ),
            __decorate(
              [pr.soapAttribute()],
              _e.prototype,
              'mainArticles',
              void 0
            ),
            __decorate(
              [pr.soapAttribute()],
              _e.prototype,
              'breakUpSetArticles',
              void 0
            ),
            __decorate([pr.soapAttribute()], _e.prototype, 'migrate', void 0),
            _e);
        function _e() {
          return (null !== Ae && Ae.apply(this, arguments)) || this;
        }
        e.OperationMode = Ie;
        var ge,
          Ne =
            ((ge = pr.SoapRequestData),
            __extends(be, ge),
            (be.FromSoap = function (e) {
              if (null != e) {
                var t = new be();
                return (
                  (t.width = ot.FromSoap(e.width)),
                  (t.height = ot.FromSoap(e.height)),
                  (t.depth = ot.FromSoap(e.depth)),
                  (t.volume = ot.FromSoap(e.volume)),
                  (t.tareWeight = ot.FromSoap(e.tareWeight)),
                  (t.netWeight = ot.FromSoap(e.netWeight)),
                  (t.itemsPerPackUnit = pr.SoapService.SoapDataToInt(
                    e.itemsPerPackUnit
                  )),
                  (t.packUnitsPerArticle = pr.SoapService.SoapDataToInt(
                    e.packUnitsPerArticle
                  )),
                  t
                );
              }
            }),
            be);
        function be() {
          return (null !== ge && ge.apply(this, arguments)) || this;
        }
        e.PackagingInfo = Ne;
        var Te,
          De =
            ((Te = pr.SoapRequestData),
            __extends(xe, Te),
            __decorate(
              [pr.soapAttribute()],
              xe.prototype,
              'doNotModify',
              void 0
            ),
            __decorate([pr.soapAttribute()], xe.prototype, 'flat', void 0),
            xe);
        function xe() {
          return (null !== Te && Te.apply(this, arguments)) || this;
        }
        e.RelocateItemsOptions = De;
        var Fe,
          Ue =
            ((Fe = pr.SoapRequestData),
            __extends(we, Fe),
            __decorate(
              [pr.soapAttribute()],
              we.prototype,
              'reuseItemIds',
              void 0
            ),
            __decorate(
              [pr.soapAttribute()],
              we.prototype,
              'returnOriginalItemIds',
              void 0
            ),
            __decorate(
              [pr.soapAttribute()],
              we.prototype,
              'ignoreComposableGeometries',
              void 0
            ),
            we);
        function we() {
          return (null !== Fe && Fe.apply(this, arguments)) || this;
        }
        e.PasteOptions = Ue;
        var Pe,
          Re =
            (__extends(je, (Pe = Ue)),
            __decorate(
              [pr.soapAttribute()],
              je.prototype,
              'setArticleIds',
              void 0
            ),
            __decorate(
              [pr.soapAttribute()],
              je.prototype,
              'geometryIds',
              void 0
            ),
            je);
        function je() {
          return (null !== Pe && Pe.apply(this, arguments)) || this;
        }
        e.PasteContainerOptions = Re;
        var Ce,
          Ee =
            ((Ce = pr.SoapRequestData),
            __extends(Le, Ce),
            (Le.FromSoap = function (e) {
              if (null != e) {
                var t = new Le();
                return (
                  (t.axis = Xe.FromSoapNU(e.axis)),
                  (t.angle = pr.SoapService.SoapDataToFloat(e.angle)),
                  t
                );
              }
            }),
            __decorate([pr.soapAttribute()], Le.prototype, 'angle', void 0),
            Le);
        function Le() {
          var e = Ce.call(this) || this;
          return (e.angle = 0), e;
        }
        e.Rotation = Ee;
        var Oe,
          Ve =
            ((Oe = pr.SoapRequestData),
            __extends(Be, Oe),
            (Be.FromSoap = function (e) {
              if (null != e) {
                var t = new Be();
                return (
                  (t.partIds = pr.SoapService.SoapDataToArray(e.partIds)),
                  (t.allPartIds = pr.SoapService.SoapDataToArray(e.allPartIds)),
                  (t.collapsed = pr.SoapService.SoapDataToBool(e.collapsed)),
                  t
                );
              }
            }),
            __decorate([pr.soapAttribute()], Be.prototype, 'collapsed', void 0),
            Be);
        function Be() {
          return (null !== Oe && Oe.apply(this, arguments)) || this;
        }
        e.SetArticleProperties = Ve;
        var ke,
          Me =
            ((ke = pr.SoapRequestData),
            __extends(Ge, ke),
            (Ge.FromSoap = function (e) {
              if (null != e) {
                var t = new Ge();
                return (t.text = e.text), t;
              }
            }),
            Ge);
        function Ge() {
          return (null !== ke && ke.apply(this, arguments)) || this;
        }
        e.TextItemProperties = Me;
        var qe,
          Xe =
            ((qe = pr.SoapRequestData),
            __extends(ze, qe),
            (ze.FromSoap = function (e) {
              if (null != e) {
                var t = new ze();
                return (
                  (t.x = pr.SoapService.SoapDataToFloat(e.x)),
                  (t.y = pr.SoapService.SoapDataToFloat(e.y)),
                  (t.z = pr.SoapService.SoapDataToFloat(e.z)),
                  t
                );
              }
            }),
            (ze.FromSoapNU = function (e) {
              if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
              return ze.FromSoap(e);
            }),
            __decorate([pr.soapAttribute()], ze.prototype, 'x', void 0),
            __decorate([pr.soapAttribute()], ze.prototype, 'y', void 0),
            __decorate([pr.soapAttribute()], ze.prototype, 'z', void 0),
            ze);
        function ze() {
          var e = qe.call(this) || this;
          return (e.x = 0), (e.y = 0), (e.z = 0), e;
        }
        e.Vector3 = Xe;
        var Ke,
          We =
            ((Ke = pr.SoapRequestData),
            __extends(He, Ke),
            (He.FromSoap = function (e) {
              if (null != e) {
                var t = e['xsi:type'];
                null == t && (t = '');
                var o,
                  r,
                  a = void 0;
                return (
                  ((a =
                    -1 < t.indexOf('Quantity')
                      ? (((o = new ot()).unit = e.unit), o)
                      : -1 < t.indexOf('Money')
                      ? (((r = new Ye()).currency = e.currency), r)
                      : new (-1 < t.indexOf('Percentage')
                          ? $e
                          : He)()).value = pr.SoapService.SoapDataToFloat(
                    e.value
                  )),
                  a
                );
              }
            }),
            __decorate([pr.soapAttribute()], He.prototype, 'value', void 0),
            He);
        function He() {
          return (null !== Ke && Ke.apply(this, arguments)) || this;
        }
        e.Value = We;
        var Qe,
          Ye =
            (__extends(Je, (Qe = We)),
            (Je.FromSoap = function (e) {
              if (null != e) {
                var t = new Je();
                return (
                  (t.currency = e.currency),
                  (t.value = pr.SoapService.SoapDataToFloat(e.value)),
                  t
                );
              }
            }),
            __decorate([pr.soapAttribute()], Je.prototype, 'currency', void 0),
            Je);
        function Je() {
          var e = Qe.call(this) || this;
          return (e.currency = ''), e;
        }
        e.Money = Ye;
        var Ze,
          $e = (__extends(et, (Ze = We)), et);
        function et() {
          return (null !== Ze && Ze.apply(this, arguments)) || this;
        }
        e.Percentage = $e;
        var tt,
          ot =
            (__extends(rt, (tt = We)),
            (rt.FromSoap = function (e) {
              if (null != e) {
                var t = new rt();
                return (
                  (t.unit = e.unit),
                  (t.value = pr.SoapService.SoapDataToFloat(e.value)),
                  t
                );
              }
            }),
            __decorate([pr.soapAttribute()], rt.prototype, 'unit', void 0),
            rt);
        function rt() {
          var e = tt.call(this) || this;
          return (e.unit = ''), e;
        }
        e.Quantity = ot;
        var at =
          ((it.prototype.getProperty = function (e, t) {
            if (null == this.properties) return null;
            for (var o = 0; o < this.properties.length; ++o)
              if (
                this.properties[o].propClass === e &&
                this.properties[o].propName === t
              )
                return this.properties[o];
            return null;
          }),
          (it.prototype.getPropertyValue = function (e, t) {
            var o = this.getProperty(e, t);
            return null != o ? o.value : null;
          }),
          (it.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new it();
            return (
              (t.baseArticleNumber = e.baseArticleNumber),
              (t.catalogIcon = e.catalogIcon),
              (t.catalogImage = e.catalogImage),
              (t.currency = e.currency),
              (t.descriptionMode = e.descriptionMode),
              (t.featureText = e.featureText),
              (t.longText = e.longText),
              (t.manufacturerId = e.manufacturerId),
              (t.seriesId = e.seriesId),
              (t.shortText = e.shortText),
              (t.variantCode = e.variantCode),
              (t.pdPurchasePrice = pr.SoapService.SoapDataToFloat(
                e.pdPurchasePrice
              )),
              (t.pdPurchasePriceComponents = To.FromSoapArray(
                e.pdPurchasePriceComponents
              )),
              (t.pdSalesPrice = pr.SoapService.SoapDataToFloat(e.pdSalesPrice)),
              (t.pdSalesPriceComponents = To.FromSoapArray(
                e.pdSalesPriceComponents
              )),
              (t.properties = jo.FromSoapArray(e.properties)),
              (t.propertyClasses = Eo.FromSoapArray(e.propertyClasses)),
              t
            );
          }),
          it);
        function it() {}
        e.ArticleData = at;
        var nt =
          ((st.FromSoapArrayNU = function (e) {
            return pr.SoapService.SoapDataToArrayNU(e, st.FromSoapNU);
          }),
          (st.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new st();
            return (
              (t.displayName = e.displayName),
              (t.displayValue = e.displayValue),
              (t.symbolicName = e.symbolicName),
              (t.symbolicValue = e.symbolicValue),
              (t.visible = pr.SoapService.SoapDataToBool(e.visible)),
              t
            );
          }),
          st);
        function st() {}
        e.ArticleFeature = nt;
        var pt =
          ((ut.prototype.getMainArticleId = function () {
            if (null != this.mainArticleId)
              return '' === this.mainArticleId ||
                '00000000-0000-0000-0000-000000000000' === this.mainArticleId
                ? this.itemId
                : this.mainArticleId;
          }),
          (ut.FromSoapArray = function (e) {
            return pr.SoapService.SoapDataToArray(e, ut.FromSoapNU);
          }),
          (ut.FromSoapArrayNU = function (e) {
            return pr.SoapService.SoapDataToArrayNU(e, ut.FromSoapNU);
          }),
          (ut.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new ut();
            return (
              (t.itemId = e.itemId),
              (t.itemType = e.itemType),
              (t.label = e.label),
              (t.mainArticleId = e.mainArticleId),
              (t.subArticleIds = pr.SoapService.SoapDataToArray(
                e.subArticleIds
              )),
              (t.subItemIds = pr.SoapService.SoapDataToArray(e.subItemIds)),
              (t.setArticlePartIds = pr.SoapService.SoapDataToArray(
                e.setArticlePartIds
              )),
              (t.basketItemIds = pr.SoapService.SoapDataToArray(
                e.basketItemIds
              )),
              (t.basketItems = ut.FromSoapArray(e.basketItems)),
              (t.setArticleId = e.setArticleId),
              (t.geometryId = e.geometryId),
              (t.positionNumber = e.positionNumber),
              t
            );
          }),
          ut);
        function ut() {}
        e.BasketItem = pt;
        var ct =
          ((lt.FromSoapArrayNU = function (e) {
            return pr.SoapService.SoapDataToArrayNU(e, lt.FromSoapNU);
          }),
          (lt.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new lt();
            return (
              (t.inactive = pr.SoapService.SoapDataToArray(e.inactive)),
              (t.description = e.description),
              (t.amount = We.FromSoap(e.amount)),
              (t.qtyRelation = ot.FromSoap(e.qtyRelation)),
              (t.value = Ye.FromSoap(e.value)),
              (t.level = pr.SoapService.SoapDataToInt(e.level)),
              (t.counter = pr.SoapService.SoapDataToInt(e.counter)),
              (t.conditionType = e.conditionType),
              (t.conditionRemovable = pr.SoapService.SoapDataToBool(
                e.conditionRemovable
              )),
              (t.amountEditable = pr.SoapService.SoapDataToBool(
                e.amountEditable
              )),
              (t.qtyRelationEditable = pr.SoapService.SoapDataToBool(
                e.qtyRelationEditable
              )),
              t
            );
          }),
          lt);
        function lt() {}
        e.CalculationLine = ct;
        var dt =
          ((mt.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new mt();
            return (
              (t.quantity = ot.FromSoap(e.quantity)),
              (t.netValue = Ye.FromSoap(e.netValue)),
              (t.tax = Ye.FromSoap(e.tax)),
              (t.lines = ct.FromSoapArrayNU(e.lines)),
              (t.addableConditions = pr.SoapService.SoapDataToArrayNU(
                e.addableConditions
              )),
              (t.currency = e.currency),
              t
            );
          }),
          mt);
        function mt() {}
        e.CalculationSheet = dt;
        var St =
          ((yt.FromSoapArrayNU = function (e) {
            return pr.SoapService.SoapDataToArrayNU(e, yt.FromSoapNU);
          }),
          (yt.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new yt();
            return (
              (t.propClass = e.propClass),
              (t.propName = e.propName),
              (t.values = Oo.FromSoapArrayNU(e.values)),
              t
            );
          }),
          yt);
        function yt() {}
        e.ChoiceList = St;
        var ft =
          ((ht.FromSoapArrayNU = function (e) {
            return pr.SoapService.SoapDataToArrayNU(e, ht.FromSoapNU);
          }),
          (ht.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new ht();
            return (
              (t.description = e.description),
              (t.accessMethod = e.accessMethod),
              (t.amountEditable = pr.SoapService.SoapDataToBool(
                e.amountEditable
              )),
              (t.calculationRule = e.calculationRule),
              (t.calculationRuleEditable = pr.SoapService.SoapDataToBool(
                e.calculationRuleEditable
              )),
              (t.conditionClass = e.conditionClass),
              (t.conditionDeletable = pr.SoapService.SoapDataToBool(
                e.conditionDeletable
              )),
              (t.conditionSign = e.conditionSign),
              (t.deferredCurrencyConversionEnabled = pr.SoapService.SoapDataToBool(
                e.deferredCurrencyConversionEnabled
              )),
              (t.editMode = e.editMode),
              (t.groupCondition = pr.SoapService.SoapDataToBool(
                e.groupCondition
              )),
              (t.headerCondition = pr.SoapService.SoapDataToBool(
                e.headerCondition
              )),
              (t.name = e.name),
              (t.quantityRelationEditable = pr.SoapService.SoapDataToBool(
                e.quantityRelationEditable
              )),
              (t.roundingRule = e.roundingRule),
              (t.valueEditable = pr.SoapService.SoapDataToBool(
                e.valueEditable
              )),
              t
            );
          }),
          ht);
        function ht() {}
        e.ConditionType = ft;
        var vt =
          ((At.FromSoapArrayNU = function (e) {
            return pr.SoapService.SoapDataToArrayNU(e, At.FromSoapNU);
          }),
          (At.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new At();
            return (
              (t.tag = e.tag),
              (t.url = e.url),
              (t.attributes = pr.SoapService.SoapDataToArray(e.attributes)),
              (t.itemId = e.itemId),
              t
            );
          }),
          At);
        function At() {}
        e.ImageInfo = vt;
        var It =
          ((_t.FromSoapArray = function (e) {
            return pr.SoapService.SoapDataToArray(e, _t.FromSoapNU);
          }),
          (_t.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new _t();
            return (
              (t.maxValue = pr.SoapService.SoapDataToFloat(e.maxValue)),
              (t.minValue = pr.SoapService.SoapDataToFloat(e.minValue)),
              t
            );
          }),
          _t);
        function _t() {}
        e.Interval = It;
        var gt =
          ((Nt.FromSoapArrayNU = function (e) {
            return pr.SoapService.SoapDataToArrayNU(e, Nt.FromSoapNU);
          }),
          (Nt.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new Nt();
            return (t.id = e.id), (t.sheet = dt.FromSoapNU(e.sheet)), t;
          }),
          Nt);
        function Nt() {}
        e.ItemCalculationSheet = gt;
        var bt =
          ((Tt.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new Tt();
            return (
              (t.addedItems = pr.SoapService.SoapDataToArray(e.addedItems)),
              (t.removedItems = pr.SoapService.SoapDataToArray(e.removedItems)),
              (t.movedItems = pr.SoapService.SoapDataToArray(e.movedItems)),
              (t.updatedItems = pr.SoapService.SoapDataToArray(e.updatedItems)),
              t
            );
          }),
          Tt);
        function Tt() {}
        e.MergeResult = bt;
        var Dt =
          ((xt.FromSoap = function (e) {
            if (null != e) {
              var t = e['xsi:type'];
              null == t && (t = '');
              var o,
                r,
                a,
                i,
                n,
                s,
                p = void 0;
              return (
                ((p =
                  -1 < t.indexOf('OAPActionChoiceAction')
                    ? (((o = new Ut()).title = e.title),
                      (o.actions = eo.FromSoapArrayNU(e.actions)),
                      (o.viewType = e.viewType),
                      (o.tileSize = e.tileSize),
                      o)
                    : -1 < t.indexOf('OAPPropChangeAction')
                    ? (((r = new Xt()).type = e.type),
                      (r.property = e.property),
                      (r.value = e.value),
                      r)
                    : -1 < t.indexOf('OAPPropEditAction')
                    ? (((a = new Wt()).title = e.title),
                      (a.properties = pr.SoapService.SoapDataToArray(
                        e.properties
                      )),
                      (a.propertyClasses = pr.SoapService.SoapDataToArray(
                        e.propertyClasses
                      )),
                      (a.visibleOnly = pr.SoapService.SoapDataToBool(
                        e.visibleOnly
                      )),
                      (a.editableOnly = pr.SoapService.SoapDataToBool(
                        e.editableOnly
                      )),
                      a)
                    : -1 < t.indexOf('OAPCreateObjectAction')
                    ? (((i = new Rt()).parent = no.FromSoap(e.parent)),
                      (i.ofmlVariantCode = e.ofmlVariantCode),
                      (i.initialPlacement = co.FromSoap(e.initialPlacement)),
                      (i.articleSpecMode = e.articleSpecMode),
                      (i.packageId = e.packageId),
                      (i.baseArticleNumber = e.baseArticleNumber),
                      i)
                    : -1 < t.indexOf('OAPMethodCallAction')
                    ? (((n = new Mt()).type = e.type),
                      (n.context = e.context),
                      (n.method = e.method),
                      (n.arguments = e.arguments),
                      n)
                    : -1 < t.indexOf('OAPDeleteObjectAction')
                    ? new Et()
                    : -1 < t.indexOf('OAPSelectObjectAction')
                    ? new Yt()
                    : -1 < t.indexOf('OAPDimChangeAction')
                    ? (((s = new Vt()).dimChanges = oo.FromSoapArray(
                        e.dimChanges
                      )),
                      s)
                    : (sr.utils.Log.warn('Unknown OAPAction type: ' + t),
                      new xt())).objects = no.FromSoapArray(e.objects)),
                (p.id = e.id),
                p
              );
            }
          }),
          (xt.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            return xt.FromSoap(e);
          }),
          xt);
        function xt() {}
        e.OAPAction = Dt;
        var Ft,
          Ut = (__extends(wt, (Ft = Dt)), wt);
        function wt() {
          return (null !== Ft && Ft.apply(this, arguments)) || this;
        }
        e.OAPActionChoiceAction = Ut;
        var Pt,
          Rt = (__extends(jt, (Pt = Dt)), jt);
        function jt() {
          return (null !== Pt && Pt.apply(this, arguments)) || this;
        }
        e.OAPCreateObjectAction = Rt;
        var Ct,
          Et = (__extends(Lt, (Ct = Dt)), Lt);
        function Lt() {
          return (null !== Ct && Ct.apply(this, arguments)) || this;
        }
        e.OAPDeleteObjectAction = Et;
        var Ot,
          Vt = (__extends(Bt, (Ot = Dt)), Bt);
        function Bt() {
          return (null !== Ot && Ot.apply(this, arguments)) || this;
        }
        e.OAPDimChangeAction = Vt;
        var kt,
          Mt = (__extends(Gt, (kt = Dt)), Gt);
        function Gt() {
          return (null !== kt && kt.apply(this, arguments)) || this;
        }
        e.OAPMethodCallAction = Mt;
        var qt,
          Xt = (__extends(zt, (qt = Dt)), zt);
        function zt() {
          return (null !== qt && qt.apply(this, arguments)) || this;
        }
        e.OAPPropChangeAction = Xt;
        var Kt,
          Wt = (__extends(Ht, (Kt = Dt)), Ht);
        function Ht() {
          return (null !== Kt && Kt.apply(this, arguments)) || this;
        }
        e.OAPPropEditAction = Wt;
        var Qt,
          Yt = (__extends(Jt, (Qt = Dt)), Jt);
        function Jt() {
          return (null !== Qt && Qt.apply(this, arguments)) || this;
        }
        e.OAPSelectObjectAction = Yt;
        var Zt =
          (($t.FromSoapArray = function (e) {
            return pr.SoapService.SoapDataToArray(e, $t.FromSoapNU);
          }),
          ($t.FromSoapArrayNU = function (e) {
            return pr.SoapService.SoapDataToArrayNU(e, $t.FromSoapNU);
          }),
          ($t.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new $t();
            return (
              (t.actionData = Dt.FromSoap(e.actionData)),
              (t.objects = pr.SoapService.SoapDataToArray(e.objects)),
              (t.referenceObject = e.referenceObject),
              (t.newObjectPosition = Xe.FromSoap(e.newObjectPosition)),
              (t.newObjectRotation = Ee.FromSoap(e.newObjectRotation)),
              (t.addedItems = pr.SoapService.SoapDataToArray(e.addedItems)),
              (t.removedItems = pr.SoapService.SoapDataToArray(e.removedItems)),
              (t.movedItems = pr.SoapService.SoapDataToArray(e.movedItems)),
              (t.updatedItems = pr.SoapService.SoapDataToArray(e.updatedItems)),
              (t.id = e.id),
              (t.state = e.state),
              t
            );
          }),
          $t);
        function $t() {}
        e.OAPActionResult = Zt;
        var eo =
          ((to.FromSoapArrayNU = function (e) {
            return pr.SoapService.SoapDataToArrayNU(e, to.FromSoapNU);
          }),
          (to.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new to();
            return (
              (t.action = Dt.FromSoap(e.action)),
              (t.actionIds = pr.SoapService.SoapDataToArray(e.actionIds)),
              (t.text = e.text),
              (t.imageFile = e.imageFile),
              t
            );
          }),
          to);
        function to() {}
        e.OAPActionListItem = eo;
        var oo =
          ((ro.FromSoapArray = function (e) {
            return pr.SoapService.SoapDataToArray(e, ro.FromSoapNU);
          }),
          (ro.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new ro();
            return (
              (t.propChoiceList = pr.SoapService.SoapDataToArray(
                e.propChoiceList,
                pr.SoapService.SoapDataToFloat
              )),
              (t.axis = e.axis),
              (t.propClass = e.propClass),
              (t.propName = e.propName),
              (t.propValue = pr.SoapService.SoapDataToFloat(e.propValue)),
              (t.minPropValue = pr.SoapService.SoapDataToFloat(e.minPropValue)),
              (t.maxPropValue = pr.SoapService.SoapDataToFloat(e.maxPropValue)),
              (t.fixedValue = pr.SoapService.SoapDataToBool(e.fixedValue)),
              (t.propDecDigits = pr.SoapService.SoapDataToFloat(
                e.propDecDigits
              )),
              (t.multiplier = pr.SoapService.SoapDataToFloat(e.multiplier)),
              (t.precision = pr.SoapService.SoapDataToFloat(e.precision)),
              t
            );
          }),
          ro);
        function ro() {}
        e.OAPDimChange = oo;
        var ao =
          ((io.FromSoapArrayNU = function (e) {
            return pr.SoapService.SoapDataToArrayNU(e, io.FromSoapNU);
          }),
          (io.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new io();
            return (
              (t.symbolOffset = Xe.FromSoap(e.symbolOffset)),
              (t.actionIds = pr.SoapService.SoapDataToArray(e.actionIds)),
              (t.symbols = po.FromSoapArray(e.symbols)),
              (t.directActionIds = pr.SoapService.SoapDataToArray(
                e.directActionIds
              )),
              (t.directActions = Zt.FromSoapArray(e.directActions)),
              (t.id = e.id),
              (t.symbolType = e.symbolType),
              (t.symbolSize = e.symbolSize),
              t
            );
          }),
          io);
        function io() {}
        e.OAPInteractor = ao;
        var no =
          ((so.FromSoapArray = function (e) {
            return pr.SoapService.SoapDataToArray(e, so.FromSoapNU);
          }),
          (so.FromSoap = function (e) {
            if (null != e) {
              var t = new so();
              return (
                (t.arguments = pr.SoapService.SoapDataToArray(e.arguments)),
                (t.category = e.category),
                t
              );
            }
          }),
          (so.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            return so.FromSoap(e);
          }),
          so);
        function so() {}
        e.OAPObjectDefinition = no;
        var po =
          ((uo.FromSoapArray = function (e) {
            return pr.SoapService.SoapDataToArrayNU(e, uo.FromSoapNU);
          }),
          (uo.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new uo();
            return (
              (t.symbolOffset = Xe.FromSoap(e.symbolOffset)),
              (t.direction = Xe.FromSoap(e.direction)),
              (t.orientationX = Xe.FromSoap(e.orientationX)),
              (t.viewAngle = pr.SoapService.SoapDataToFloat(e.viewAngle)),
              (t.hiddenMode = pr.SoapService.SoapDataToBool(e.hiddenMode)),
              t
            );
          }),
          uo);
        function uo() {}
        e.OAPSymbolDisplay = po;
        var co =
          ((lo.FromSoap = function (e) {
            if (null != e) {
              var t,
                o,
                r = e['xsi:type'];
              return (
                null == r && (r = ''),
                -1 < r.indexOf('OAPDataDefinedPlacement')
                  ? (((t = new So()).referenceObject = no.FromSoap(
                      e.referenceObject
                    )),
                    (t.attachPoint = e.attachPoint),
                    t)
                  : -1 < r.indexOf('OAPAttachAreasPlacement')
                  ? (((o = new ho()).referenceObject = no.FromSoapNU(
                      e.referenceObject
                    )),
                    (o.refObjectAttachAreaIds = pr.SoapService.SoapDataToArrayNU(
                      e.refObjectAttachAreaIds
                    )),
                    (o.newObjectAttachAreaId = e.newObjectAttachAreaId),
                    o)
                  : (sr.utils.Log.warn('Unknown OAPPlacement type: ' + r),
                    new lo())
              );
            }
          }),
          lo);
        function lo() {}
        e.OAPPlacement = co;
        var mo,
          So = (__extends(yo, (mo = co)), yo);
        function yo() {
          return (null !== mo && mo.apply(this, arguments)) || this;
        }
        e.OAPDataDefinedPlacement = So;
        var fo,
          ho = (__extends(vo, (fo = co)), vo);
        function vo() {
          return (null !== fo && fo.apply(this, arguments)) || this;
        }
        e.OAPAttachAreasPlacement = ho;
        var Ao =
          ((Io.FromSoapArray = function (e) {
            return pr.SoapService.SoapDataToArray(e, Io.FromSoapNU);
          }),
          (Io.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new Io();
            return (
              (t.order = pr.SoapService.SoapDataToInt(e.order)),
              (t.typeId = e.typeId),
              t
            );
          }),
          Io);
        function Io() {}
        e.OrderedTax = Ao;
        var _o =
          ((go.FromSoap = function (e) {
            if (null != e) {
              var t = new go();
              return (
                (t.items = pt.FromSoapArrayNU(e.items)),
                (t.itemGeometries = pr.SoapService.SoapDataToArrayNU(
                  e.itemGeometries
                )),
                (t.originalItemIds = pr.SoapService.SoapDataToArray(
                  e.originalItemIds
                )),
                (t.sceneGeometry = e.sceneGeometry),
                t
              );
            }
          }),
          go);
        function go() {}
        e.PasteContainerResult = _o;
        var No =
          ((bo.FromSoap = function (e) {
            if (null != e) {
              var t = new bo();
              return (
                (t.unitSize = ot.FromSoap(e.unitSize)),
                (t.netPrice = Ye.FromSoap(e.netPrice)),
                (t.netValue = Ye.FromSoap(e.netValue)),
                (t.tax = Ye.FromSoap(e.tax)),
                (t.inactive = pr.SoapService.SoapDataToBool(e.inactive)),
                (t.quantity = pr.SoapService.SoapDataToFloat(e.quantity)),
                t
              );
            }
          }),
          bo);
        function bo() {}
        e.PriceInfo = No;
        var To =
          ((Do.FromSoapArray = function (e) {
            return pr.SoapService.SoapDataToArray(e, Do.FromSoapNU);
          }),
          (Do.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new Do();
            return (
              (t.name = e.name),
              (t.value = pr.SoapService.SoapDataToFloat(e.value)),
              t
            );
          }),
          Do);
        function Do() {}
        e.PriceComponent = To;
        var xo =
          ((Fo.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new Fo();
            return (
              (t.displayName = e.displayName),
              (t.lines = Po.FromSoapArrayNU(e.lines)),
              (t.halfWayRoundingMode = e.halfWayRoundingMode),
              (t.name = e.name),
              t
            );
          }),
          Fo);
        function Fo() {}
        e.PricingProcedure = xo;
        var Uo =
          ((wo.FromSoapArrayNU = function (e) {
            return pr.SoapService.SoapDataToArrayNU(e, wo.FromSoapNU);
          }),
          (wo.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new wo();
            return (t.displayName = e.displayName), (t.name = e.name), t;
          }),
          wo);
        function wo() {}
        e.PricingProcedureDescription = Uo;
        var Po =
          ((Ro.FromSoapArrayNU = function (e) {
            return pr.SoapService.SoapDataToArrayNU(e, Ro.FromSoapNU);
          }),
          (Ro.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new Ro();
            return (
              (t.description = e.description),
              (t.tags = pr.SoapService.SoapDataToArray(e.tags)),
              (t.conditionType = e.conditionType),
              (t.counter = pr.SoapService.SoapDataToInt(e.counter)),
              (t.from = pr.SoapService.SoapDataToInt(e.from)),
              (t.insertMode = e.insertMode),
              (t.level = pr.SoapService.SoapDataToInt(e.level)),
              (t.lineType = e.lineType),
              (t.maxOccurs = pr.SoapService.SoapDataToInt(e.maxOccurs)),
              (t.printControl = e.printControl),
              (t.to = pr.SoapService.SoapDataToInt(e.to)),
              t
            );
          }),
          Ro);
        function Ro() {}
        e.PricingProcedureLine = Po;
        var jo =
          ((Co.FromSoapArray = function (e) {
            return pr.SoapService.SoapDataToArray(e, Co.FromSoapNU);
          }),
          (Co.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new Co();
            return (
              (t.addValues = pr.SoapService.SoapDataToBool(e.addValues)),
              (t.choiceList = pr.SoapService.SoapDataToBool(e.choiceList)),
              (t.decDigits = pr.SoapService.SoapDataToInt(e.decDigits)),
              (t.digits = pr.SoapService.SoapDataToInt(e.digits)),
              (t.editable = pr.SoapService.SoapDataToBool(e.editable)),
              (t.intervals = It.FromSoapArray(e.intervals)),
              (t.propClass = e.propClass),
              (t.propName = e.propName),
              (t.propText = e.propText),
              (t.type = e.type),
              (t.value = Oo.FromSoapNU(e.value)),
              (t.visible = pr.SoapService.SoapDataToBool(e.visible)),
              (t.width = pr.SoapService.SoapDataToInt(e.width)),
              t
            );
          }),
          Co);
        function Co() {}
        e.Property = jo;
        var Eo =
          ((Lo.FromSoapArray = function (e) {
            return pr.SoapService.SoapDataToArray(e, Lo.FromSoapNU);
          }),
          (Lo.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new Lo();
            return (t.description = e.description), (t.name = e.name), t;
          }),
          Lo);
        function Lo() {}
        e.PropertyClass = Eo;
        var Oo =
          ((Vo.FromSoapArray = function (e) {
            return pr.SoapService.SoapDataToArray(e, Vo.FromSoapNU);
          }),
          (Vo.FromSoapArrayNU = function (e) {
            return pr.SoapService.SoapDataToArrayNU(e, Vo.FromSoapNU);
          }),
          (Vo.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new Vo();
            return (
              (t.largeIcon = e.largeIcon),
              (t.smallIcon = e.smallIcon),
              (t.text = e.text),
              (t.value = e.value),
              t
            );
          }),
          Vo);
        function Vo() {}
        e.PropertyValue = Oo;
        var Bo =
          ((ko.FromSoapArray = function (e) {
            return pr.SoapService.SoapDataToArray(e, ko.FromSoapNU);
          }),
          (ko.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new ko();
            return (
              (t.name = e.name),
              (t.identifier = e.identifier),
              (t.rate = pr.SoapService.SoapDataToFloat(e.rate)),
              (t.rateReadOnly = pr.SoapService.SoapDataToBool(e.rateReadOnly)),
              t
            );
          }),
          ko);
        function ko() {}
        e.TaxCategory = Bo;
        var Mo =
          ((Go.FromSoapArrayNU = function (e) {
            return pr.SoapService.SoapDataToArrayNU(e, Go.FromSoapNU);
          }),
          (Go.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new Go();
            return (t.taxCategory = e.taxCategory), (t.taxType = e.taxType), t;
          }),
          Go);
        function Go() {}
        e.TaxInfo = Mo;
        var qo =
          ((Xo.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new Xo();
            return (
              (t.variantName = e.variantName),
              (t.taxTypes = zo.FromSoapArray(e.taxTypes)),
              (t.orderedTaxes = Ao.FromSoapArray(e.orderedTaxes)),
              (t.country = e.country),
              (t.currency = e.currency),
              (t.identifier = e.identifier),
              (t.region = e.region),
              t
            );
          }),
          Xo);
        function Xo() {}
        e.TaxScheme = qo;
        var zo =
          ((Ko.FromSoapArray = function (e) {
            return pr.SoapService.SoapDataToArray(e, Ko.FromSoapNU);
          }),
          (Ko.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new Ko();
            return (
              (t.abbreviation = e.abbreviation),
              (t.name = e.name),
              (t.taxCategories = Bo.FromSoapArray(e.taxCategories)),
              (t.identifier = e.identifier),
              (t.rateUnit = e.rateUnit),
              t
            );
          }),
          Ko);
        function Ko() {}
        e.TaxType = zo;
        var Wo =
          ((Ho.FromSoapArrayNU = function (e) {
            return pr.SoapService.SoapDataToArrayNU(e, Ho.FromSoapNU);
          }),
          (Ho.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new Ho();
            return (
              (t.variantName = e.variantName),
              (t.country = e.country),
              (t.identifier = e.identifier),
              (t.region = e.region),
              t
            );
          }),
          Ho);
        function Ho() {}
        e.TaxSchemeDescription = Wo;
        var Qo =
          ((Yo.FromSoapArrayNU = function (e) {
            return pr.SoapService.SoapDataToArrayNU(e, Yo.FromSoapNU);
          }),
          (Yo.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new Yo();
            return (
              (t.displayName = e.displayName), (t.columnId = e.columnId), t
            );
          }),
          Yo);
        function Yo() {}
        e.TMColumnDef = Qo;
        var Jo =
          ((Zo.FromSoapArrayNU = function (e) {
            return pr.SoapService.SoapDataToArrayNU(e, Zo.FromSoapNU);
          }),
          (Zo.FromSoapArray = function (e) {
            return pr.SoapService.SoapDataToArray(e, Zo.FromSoapNU);
          }),
          (Zo.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new Zo();
            return (
              (t.texts = rr.FromSoapArrayNU(e.texts)),
              (t.textId = e.textId),
              (t.readOnly = pr.SoapService.SoapDataToBool(e.readOnly)),
              (t.visible = pr.SoapService.SoapDataToBool(e.visible)),
              t
            );
          }),
          Zo);
        function Zo() {}
        e.TMRow = Jo;
        var $o =
          ((er.FromSoapArrayNU = function (e) {
            return pr.SoapService.SoapDataToArrayNU(e, er.FromSoapNU);
          }),
          (er.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new er();
            return (
              (t.displayName = e.displayName),
              (t.type = e.type),
              (t.textId = e.textId),
              (t.readOnly = pr.SoapService.SoapDataToBool(e.readOnly)),
              (t.defaultVisible = pr.SoapService.SoapDataToBool(
                e.defaultVisible
              )),
              t
            );
          }),
          er);
        function er() {}
        e.TMRowDef = $o;
        var tr =
          ((or.FromSoap = function (e) {
            if (null != e) {
              var t = new or();
              return (
                (t.columns = Qo.FromSoapArrayNU(e.columns)),
                (t.rows = $o.FromSoapArrayNU(e.rows)),
                t
              );
            }
          }),
          or);
        function or() {}
        e.TMTable = tr;
        var rr =
          ((ar.FromSoapArrayNU = function (e) {
            return pr.SoapService.SoapDataToArrayNU(e, ar.FromSoapNU);
          }),
          (ar.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new ar();
            return (t.text = e.text), (t.language = e.language), t;
          }),
          ar);
        function ar() {}
        e.TMText = rr;
        var ir =
          ((nr.FromSoapArrayNU = function (e) {
            return pr.SoapService.SoapDataToArrayNU(e, nr.FromSoapNU);
          }),
          (nr.FromSoapNU = function (e) {
            if (null == e) throw new Error(sr.utils.ERR_INVALID_ARGUMENT);
            var t = new nr();
            return (t.itemId = e.itemId), (t.updateState = e.updateState), t;
          }),
          nr);
        function nr() {}
        e.UpdateBasketArticleResult = ir;
      })((pr = sr.eaiws || (sr.eaiws = {})).basket || (pr.basket = {}));
  })((egr = egr || {})),
  (function (e) {
    var o, t, a, r;
    function i(e, t) {
      (this.mProcedure = e), (this.mSheet = t), this.prepareInfo();
    }
    (o = e.wcf || (e.wcf = {})),
      (t = o.eaiws || (o.eaiws = {})),
      (a = t.basket || (t.basket = {})),
      Object.defineProperty(i.prototype, 'procedure', {
        get: function () {
          return this.mProcedure;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(i.prototype, 'sheet', {
        get: function () {
          return this.mSheet;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(i.prototype, 'purchasePrice', {
        get: function () {
          return this.mPurchasePrice;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(i.prototype, 'unitPurchasePrice', {
        get: function () {
          return this.mUnitPurchasePrice;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(i.prototype, 'salesPrice', {
        get: function () {
          return this.mSalesPrice;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(i.prototype, 'unitSalesPrice', {
        get: function () {
          return this.mUnitSalesPrice;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(i.prototype, 'itemNetPrice', {
        get: function () {
          return this.mItemNetPrice;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(i.prototype, 'unitItemNetPrice', {
        get: function () {
          return this.mUnitItemNetPrice;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(i.prototype, 'netPrice', {
        get: function () {
          return this.mNetPrice;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(i.prototype, 'unitNetPrice', {
        get: function () {
          return this.mUnitNetPrice;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(i.prototype, 'grossPrice', {
        get: function () {
          return this.mGrossPrice;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(i.prototype, 'unitGrossPrice', {
        get: function () {
          return this.mUnitGrossPrice;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (i.prototype.getLineTags = function (e) {
        var t = this.mProcedure.getProcedureLine(e.level, e.counter, !0);
        if (null == t)
          throw o.utils.newError(
            o.utils.ERR_INVALID_ARGUMENT,
            'unknown calculation line'
          );
        return this.procedure.getLineTags(t);
      }),
      (i.prototype.prepareInfo = function () {
        for (var e = 0, t = this.mSheet.lines; e < t.length; e++) {
          var o = t[e],
            r = this.mProcedure.getProcedureLine(o.level, o.counter, !0);
          if (null != r) {
            var a = r.tags;
            if (!(null == a || a.length < 1))
              for (var i = 0, n = a; i < n.length; i++)
                switch (n[i]) {
                  case 'GROSS_PURCHASE_PRICE':
                    (this.mPurchasePrice = o.value),
                      (this.mUnitPurchasePrice = this.getUnitPrice(
                        o.value,
                        o.amount
                      ));
                    break;
                  case 'GROSS_SALES_PRICE':
                    (this.mSalesPrice = o.value),
                      (this.mUnitSalesPrice = this.getUnitPrice(
                        o.value,
                        o.amount
                      ));
                    break;
                  case 'ITEM_NET_VALUE':
                    (this.mItemNetPrice = o.value),
                      (this.mUnitItemNetPrice = this.getUnitPrice(
                        o.value,
                        o.amount
                      ));
                    break;
                  case 'NET_VALUE':
                    (this.mNetPrice = o.value),
                      (this.mUnitNetPrice = this.getUnitPrice(
                        o.value,
                        o.amount
                      ));
                    break;
                  case 'FINAL_VALUE':
                    (this.mGrossPrice = o.value),
                      (this.mUnitGrossPrice = this.getUnitPrice(
                        o.value,
                        o.amount
                      ));
                }
          }
        }
      }),
      (i.prototype.getUnitPrice = function (e, t) {
        if (null != e) {
          var o = e.value;
          null != t
            ? (o = t.value)
            : null != o &&
              null != this.mSheet.quantity &&
              null != this.mSheet.quantity.value &&
              0 != this.mSheet.quantity.value &&
              (o /= this.mSheet.quantity.value);
          var r = new a.Money();
          return (r.value = o), (r.currency = e.currency), r;
        }
      }),
      (r = i),
      (a.CalculationSheetInfo = r);
  })((egr = egr || {})),
  (function (e) {
    var n, t, o, r;
    function s(e, t) {
      (this.mProcedure = e), (this.mTypes = new Map());
      for (var o = 0, r = t; o < r.length; o++) {
        var a = r[o];
        this.mTypes.set(a.name, a);
      }
      (this.mLines = new Map()), (this.mLineTags = new Map());
      for (var i = 0, n = this.mProcedure.lines; i < n.length; i++) {
        var s = n[i],
          p = s.level.toString() + '_' + s.counter.toString();
        this.mLines.set(p, s);
        var u = new Set();
        if (null != s.tags)
          for (var c = 0, l = s.tags; c < l.length; c++) {
            var d = l[c];
            u.add(d);
          }
        this.mLineTags.set(s, u);
      }
    }
    (n = e.wcf || (e.wcf = {})),
      (t = n.eaiws || (n.eaiws = {})),
      (o = t.basket || (t.basket = {})),
      Object.defineProperty(s.prototype, 'name', {
        get: function () {
          return this.mProcedure.name;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(s.prototype, 'procedure', {
        get: function () {
          return this.mProcedure;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (s.prototype.getConditionType = function (e) {
        return this.mTypes.get(e);
      }),
      (s.prototype.getProcedureLine = function (e, t, o) {
        void 0 === o && (o = !0);
        var r = e.toString() + '_' + t.toString(),
          a = this.mLines.get(r);
        return o && null == a && 0 !== t ? this.getProcedureLine(e, 0, !1) : a;
      }),
      (s.prototype.getLineTags = function (e) {
        var t = this.mLineTags.get(e);
        if (null == t)
          throw n.utils.newError(
            n.utils.ERR_INVALID_ARGUMENT,
            'unknown pricing procedure line'
          );
        return t;
      }),
      (s.CreateInfo = function (r, a, i) {
        return (
          void 0 === i && (i = !0),
          __awaiter(this, void 0, void 0, function () {
            var t, o;
            return __generator(this, function (e) {
              switch (e.label) {
                case 0:
                  if (!r.isValid)
                    throw n.utils.newError(
                      n.utils.ERR_INVALID_STATE,
                      'session not valid'
                    );
                  return [4, r.basket.getPricingProcedure(i, a)];
                case 1:
                  return (t = e.sent()), [4, r.basket.getConditionTypes(i, a)];
                case 2:
                  return (o = e.sent()), [2, new s(t, o)];
              }
            });
          })
        );
      }),
      (r = s),
      (o.PricingProcedureInfo = r);
  })((egr = egr || {})),
  (function (e) {
    var r, o, a, i, t;
    function n(e, t, o) {
      return (
        i.call(
          this,
          e,
          r.utils.string.joinPath(t, 'EAI/Catalog'),
          'http://catalog.ws.eai.egr/',
          o
        ) || this
      );
    }
    (r = e.wcf || (e.wcf = {})),
      (o = r.eaiws || (r.eaiws = {})),
      (a = o.catalog || (o.catalog = {})),
      (i = o.BaseEaiwsService),
      __extends(n, i),
      (n.prototype.getCatalogItem = function (e, t) {
        return this.soapAjax('getCatalogItem', {
          sessionId: this.mSessionId,
          path: e,
          options: t,
        }).then(function (e) {
          return a.CatalogItem.FromSoapNU(e);
        });
      }),
      (n.prototype.getCatalogPath = function (e, t) {
        return this.soapAjax('getCatalogPath', {
          sessionId: this.mSessionId,
          catalogId: e,
          catNodeKey: t,
        }).then(function (e) {
          return o.SoapService.SoapDataToArrayNU(e);
        });
      }),
      (n.prototype.getLanguages = function () {
        var t = this;
        return null != this.mLanguages
          ? Promise.resolve(this.mLanguages)
          : this.soapAjax('getLanguages', { sessionId: this.mSessionId }).then(
              function (e) {
                return (
                  (t.mLanguages = o.SoapService.SoapDataToArrayNU(e)),
                  t.mLanguages
                );
              }
            );
      }),
      (n.prototype.listCatalogItems = function (e, t) {
        return this.soapAjax('listCatalogItems', {
          sessionId: this.mSessionId,
          path: e,
          options: t,
        }).then(function (e) {
          return a.CatalogItem.FromSoapArrayNU(e);
        });
      }),
      (n.prototype.searchArticle = function (e, t) {
        return this.soapAjax('searchArticle', {
          sessionId: this.mSessionId,
          search: e,
          options: t,
        }).then(function (e) {
          return a.TopCatalogItems.FromSoap(e);
        });
      }),
      (n.prototype.searchCatalogItems = function (e, t) {
        return this.soapAjax('searchCatalogItems', {
          sessionId: this.mSessionId,
          search: e,
          options: t,
        }).then(function (e) {
          return a.TopCatalogItems.FromSoap(e);
        });
      }),
      (n.prototype.setLanguages = function (e) {
        var t = this;
        return this.soapAjax('setLanguages', {
          sessionId: this.mSessionId,
          languages: e,
        }).then(function () {
          (t.mLanguages = void 0),
            t.mOwner.eventCatalogLanguagesChanged.trigger();
        });
      }),
      (n.prototype._clearCache = function () {
        this.mLanguages = void 0;
      }),
      (t = n),
      (a.CatalogService = t);
  })((egr = egr || {})),
  (function (e) {
    var b, T;
    (b = e.wcf || (e.wcf = {})),
      (function (e) {
        var t,
          o =
            ((t = T.SoapRequestData),
            __extends(r, t),
            __decorate(
              [T.soapAttribute()],
              r.prototype,
              'firstHitPosition',
              void 0
            ),
            __decorate(
              [T.soapAttribute()],
              r.prototype,
              'numberOfHits',
              void 0
            ),
            r);
        function r() {
          var e = t.call(this) || this;
          return (e.catalogIds = null), e;
        }
        e.BasicSearchParameterSet = o;
        var a,
          i =
            ((a = T.SoapRequestData),
            __extends(n, a),
            __decorate([T.soapAttribute()], n.prototype, 'displayMode', void 0),
            __decorate([T.soapAttribute()], n.prototype, 'descriptors', void 0),
            __decorate(
              [T.soapAttribute()],
              n.prototype,
              'subCategories',
              void 0
            ),
            __decorate([T.soapAttribute()], n.prototype, 'synonyms', void 0),
            n);
        function n() {
          return (null !== a && a.apply(this, arguments)) || this;
        }
        e.LookupOptions = i;
        var s,
          p =
            (__extends(u, (s = o)),
            __decorate([T.soapAttribute()], u.prototype, 'brandId', void 0),
            __decorate(
              [T.soapAttribute()],
              u.prototype,
              'manufacturerId',
              void 0
            ),
            __decorate([T.soapAttribute()], u.prototype, 'seriesId', void 0),
            __decorate(
              [T.soapAttribute()],
              u.prototype,
              'baseArticleNumber',
              void 0
            ),
            __decorate([T.soapAttribute()], u.prototype, 'varCodeType', void 0),
            __decorate([T.soapAttribute()], u.prototype, 'variantCode', void 0),
            u);
        function u() {
          return (null !== s && s.apply(this, arguments)) || this;
        }
        e.SearchArticleParameterSet = p;
        var c,
          l = (__extends(d, (c = o)), d);
        function d() {
          var e = c.call(this) || this;
          return (e.query = ''), e;
        }
        e.SearchParameterSet = l;
        var m =
          ((S.FromSoapArrayNU = function (e) {
            return T.SoapService.SoapDataToArrayNU(e, S.FromSoapNU);
          }),
          (S.FromSoapNU = function (e) {
            if (null == e) throw new Error(b.utils.ERR_INVALID_ARGUMENT);
            var t = e['xsi:type'];
            null == t && (t = '');
            var o,
              r = null;
            return (
              ((r =
                -1 < t.indexOf('ArticleCatalogItem')
                  ? (((o = new f()).articlePackageId = e.articlePackageId),
                    (o.baseArticleNumber = e.baseArticleNumber),
                    (o.varCodeType = e.varCodeType),
                    (o.variantCode = e.variantCode),
                    o)
                  : new S()).catalogId = e.catalogId),
              (r.catalogNodeKey = e.catalogNodeKey),
              (r.catalogPackageId = e.catalogPackageId),
              (r.label = e.label),
              (r.icon = e.icon),
              (r.name = e.name),
              (r.type = e.type),
              (r.resources = v.FromSoapArray(e.resources)),
              r
            );
          }),
          S);
        function S() {}
        e.CatalogItem = m;
        var y,
          f = (__extends(h, (y = m)), h);
        function h() {
          return (null !== y && y.apply(this, arguments)) || this;
        }
        e.ArticleCatalogItem = f;
        var v =
          ((A.FromSoapArray = function (e) {
            return T.SoapService.SoapDataToArray(e, A.FromSoapNU);
          }),
          (A.FromSoapNU = function (e) {
            if (null == e) throw new Error(b.utils.ERR_INVALID_ARGUMENT);
            var t = new A();
            return (
              (t.language = e.language),
              (t.type = e.type),
              (t.value = e.value),
              t
            );
          }),
          A);
        function A() {}
        e.CatalogResource = v;
        var I =
          ((_.FromSoapArrayNU = function (e) {
            return T.SoapService.SoapDataToArrayNU(e, _.FromSoapNU);
          }),
          (_.FromSoapNU = function (e) {
            if (null == e) throw new Error(b.utils.ERR_INVALID_ARGUMENT);
            var t = new _();
            return (
              (t.item = m.FromSoapNU(e.item)),
              (t.score = T.SoapService.SoapDataToFloat(e.score)),
              t
            );
          }),
          _);
        function _() {}
        e.ScoredCatalogItem = I;
        var g =
          ((N.FromSoap = function (e) {
            if (null != e) {
              var t = new N();
              return (
                (t.scoredItems = I.FromSoapArrayNU(e.scoredItems)),
                (t.totalHits = T.SoapService.SoapDataToInt(e.totalHits)),
                t
              );
            }
          }),
          N);
        function N() {}
        e.TopCatalogItems = g;
      })((T = b.eaiws || (b.eaiws = {})).catalog || (T.catalog = {}));
  })((egr = egr || {})),
  (function (e) {
    var o, r, t, a, i, n, s, p;
    function u(e, t) {
      return (
        a.call(
          this,
          o.utils.string.joinPath(e, 'EAIWS/plugins/PriceProfile'),
          'http://price_profile.plugins.eai.egr/',
          t
        ) || this
      );
    }
    function c() {
      var e = n.call(this) || this;
      return (e.value = 0), e;
    }
    (o = e.wcf || (e.wcf = {})),
      (r = o.eaiws || (o.eaiws = {})),
      (t = r.plugins || (r.plugins = {})),
      (a = r.SoapService),
      __extends(u, a),
      (u.prototype.addRules = function (e, t) {
        return this.soapAjax('addRules', {
          sessionId: this.mSessionId,
          accMeth: e,
          rules: t,
        });
      }),
      (u.prototype.getRules = function (e) {
        return this.soapAjax('getRules', {
          sessionId: this.mSessionId,
          accMeth: e,
        }).then(function (e) {
          return u.ConditionRule.FromSoapArrayNU(e);
        });
      }),
      (u.prototype.loadCsv = function (e, t) {
        return this.soapAjax('loadCsv', {
          sessionId: this.mSessionId,
          accMeth: e,
          csvPath: t,
        });
      }),
      (u.prototype.removeRules = function (e) {
        return this.soapAjax('removeRules', {
          sessionId: this.mSessionId,
          accMeth: e,
        });
      }),
      (u.prototype._clearCache = function () {}),
      (p = u),
      (t.PriceProfileService = p),
      (i = p = t.PriceProfileService || (t.PriceProfileService = {})),
      (n = r.SoapRequestData),
      __extends(c, n),
      (c.FromSoapArrayNU = function (e) {
        return r.SoapService.SoapDataToArrayNU(e, c.FromSoapNU);
      }),
      (c.FromSoapNU = function (e) {
        if (null == e) throw new Error(o.utils.ERR_INVALID_ARGUMENT);
        var t = new c();
        return (
          (t.manufacturer = e.manufacturer),
          (t.series = e.series),
          (t.baseArticleNumber = e.baseArticleNumber),
          (t.finalArticleNumber = e.finalArticleNumber),
          (t.value = r.SoapService.SoapDataToFloat(e.value)),
          (t.currency = e.currency),
          t
        );
      }),
      __decorate([r.soapAttribute()], c.prototype, 'manufacturer', void 0),
      __decorate([r.soapAttribute()], c.prototype, 'series', void 0),
      __decorate([r.soapAttribute()], c.prototype, 'baseArticleNumber', void 0),
      __decorate(
        [r.soapAttribute()],
        c.prototype,
        'finalArticleNumber',
        void 0
      ),
      __decorate([r.soapAttribute()], c.prototype, 'value', void 0),
      __decorate([r.soapAttribute()], c.prototype, 'currency', void 0),
      (s = c),
      (i.ConditionRule = s);
  })((egr = egr || {})),
  (function (e) {
    var r, o, t, a, i;
    function n(e, t, o) {
      return (
        a.call(
          this,
          e,
          r.utils.string.joinPath(t, 'EAI/Project'),
          'http://project.ws.eai.egr/',
          o
        ) || this
      );
    }
    (r = e.wcf || (e.wcf = {})),
      (o = r.eaiws || (r.eaiws = {})),
      (t = o.project || (o.project = {})),
      (a = o.BaseEaiwsService),
      __extends(n, a),
      (n.prototype.addPriceList = function (e, t, o) {
        return this.soapAjax('addPriceList', {
          sessionId: this.mSessionId,
          id: e,
          startup: t,
          displayName: o,
        });
      }),
      (n.prototype.addProjectGroup = function (e, t, o, r) {
        return this.soapAjax('addProjectGroup', {
          sessionId: this.mSessionId,
          id: e,
          folder: t,
          simpleName: o,
          subgroupTitle: r,
        });
      }),
      (n.prototype.addProjectNumberScheme = function (e, t, o, r) {
        return this.soapAjax('addProjectNumberScheme', {
          sessionId: this.mSessionId,
          id: e,
          pattern: t,
          minValue: o,
          maxValue: r,
        });
      }),
      (n.prototype.authenticateUser = function (e, t) {
        return this.soapAjax('authenticateUser', {
          sessionId: this.mSessionId,
          messageType: e,
          message: t,
        });
      }),
      (n.prototype.deleteProjects = function (e, t) {
        return this.soapAjax('deleteProjects', {
          sessionId: this.mSessionId,
          uris: e,
          options: t,
        }).then(function (e) {
          return o.SoapService.SoapDataToArrayNU(e);
        });
      }),
      (n.prototype.getAddressData = function (e) {
        return this.soapAjax('getAddressData', {
          sessionId: this.mSessionId,
          addressTypes: e,
        }).then(function (e) {
          return t.AddressData.FromSoapArrayNU(e);
        });
      }),
      (n.prototype.getContactData = function () {
        return this.soapAjax('getContactData', {
          sessionId: this.mSessionId,
        }).then(function (e) {
          return t.ContactData.FromSoapArrayNU(e);
        });
      }),
      (n.prototype.getCountries = function () {
        return this.soapAjax('getCountries', {
          sessionId: this.mSessionId,
        }).then(function (e) {
          return t.CountryData.FromSoapArrayNU(e);
        });
      }),
      (n.prototype.getCountrySubdivisions = function (e) {
        return this.soapAjax('getCountrySubdivisions', {
          sessionId: this.mSessionId,
          countryCode: e,
        }).then(function (e) {
          return t.SubdivisionData.FromSoapArrayNU(e);
        });
      }),
      (n.prototype.getPriceLists = function (e) {
        return this.soapAjax('getPriceLists', {
          sessionId: this.mSessionId,
          idPattern: e,
        }).then(function (e) {
          return t.PriceList.FromSoapArrayNU(e);
        });
      }),
      (n.prototype.getProjectData = function () {
        return this.soapAjax('getProjectData', {
          sessionId: this.mSessionId,
        }).then(function (e) {
          return t.ProjectData.FromSoap(e);
        });
      }),
      (n.prototype.getProjectGroups = function (e) {
        return this.soapAjax('getProjectGroups', {
          sessionId: this.mSessionId,
          idPattern: e,
        }).then(function (e) {
          return t.ProjectGroup.FromSoapArrayNU(e);
        });
      }),
      (n.prototype.getProjectNumberSchemes = function (e) {
        return this.soapAjax('getProjectNumberSchemes', {
          sessionId: this.mSessionId,
          idPattern: e,
        }).then(function (e) {
          return t.ProjectNumberScheme.FromSoapArrayNU(e);
        });
      }),
      (n.prototype.listCompletions = function (e) {
        return this.soapAjax('listCompletions', {
          sessionId: this.mSessionId,
          options: e,
        }).then(function (e) {
          return o.SoapService.SoapDataToArrayNU(e);
        });
      }),
      (n.prototype.listProjects = function (e) {
        return this.soapAjax('listProjects', {
          sessionId: this.mSessionId,
          options: e,
        }).then(function (e) {
          return t.ProjectData.FromSoapArrayNU(e);
        });
      }),
      (n.prototype.loadProject = function (e, t) {
        return this.soapAjax('loadProject', {
          sessionId: this.mSessionId,
          uri: e,
          lockMode: t,
        });
      }),
      (n.prototype.newProject = function (e, t) {
        return this.soapAjax('newProject', {
          sessionId: this.mSessionId,
          projectGroup: e,
          priceList: t,
        });
      }),
      (n.prototype.removeAddressData = function (e) {
        return this.soapAjax('removeAddressData', {
          sessionId: this.mSessionId,
          addressTypes: e,
        }).then(function (e) {
          return o.SoapService.SoapDataToArrayNU(e);
        });
      }),
      (n.prototype.removeContactData = function (e, t) {
        return this.soapAjax('removeContactData', {
          sessionId: this.mSessionId,
          addressType: e,
          contactIds: t,
        }).then(function (e) {
          return o.SoapService.SoapDataToArrayNU(
            e,
            o.SoapService.SoapDataToInt
          );
        });
      }),
      (n.prototype.removePriceList = function (e) {
        return this.soapAjax('removePriceList', {
          sessionId: this.mSessionId,
          id: e,
        });
      }),
      (n.prototype.removeProjectGroup = function (e) {
        return this.soapAjax('removeProjectGroup', {
          sessionId: this.mSessionId,
          id: e,
        });
      }),
      (n.prototype.removeProjectNumberScheme = function (e) {
        return this.soapAjax('removeProjectNumberScheme', {
          sessionId: this.mSessionId,
          id: e,
        });
      }),
      (n.prototype.saveProject = function (e) {
        return this.soapAjax('saveProject', {
          sessionId: this.mSessionId,
          options: e,
        });
      }),
      (n.prototype.setAddressData = function (e) {
        return this.soapAjax('setAddressData', {
          sessionId: this.mSessionId,
          address: e,
        });
      }),
      (n.prototype.setAutoSaveOptions = function (e) {
        return this.soapAjax('setAutoSaveOptions', {
          sessionId: this.mSessionId,
          options: e,
        }).then(function (e) {
          return t.AutoSaveOptions.FromSoap(e);
        });
      }),
      (n.prototype.setContactData = function (e) {
        return this.soapAjax('setContactData', {
          sessionId: this.mSessionId,
          contact: e,
        });
      }),
      (n.prototype.setProjectData = function (e) {
        return this.soapAjax('setProjectData', {
          sessionId: this.mSessionId,
          data: e,
        });
      }),
      (n.prototype.updatePriceList = function (e) {
        return this.soapAjax('updatePriceList', {
          sessionId: this.mSessionId,
          priceList: e,
        });
      }),
      (n.prototype.updateProjectGroup = function (e) {
        return this.soapAjax('updateProjectGroup', {
          sessionId: this.mSessionId,
          projectGroup: e,
        });
      }),
      (n.prototype.updateProjectLock = function (e) {
        return this.soapAjax('updateProjectLock', {
          sessionId: this.mSessionId,
          lockMode: e,
        }).then(function (e) {
          return o.SoapService.SoapDataToBool(e);
        });
      }),
      (n.prototype.updateProjectNumberScheme = function (e) {
        return this.soapAjax('updateProjectNumberScheme', {
          sessionId: this.mSessionId,
          numberScheme: e,
        });
      }),
      (n.prototype._clearCache = function () {}),
      (i = n),
      (t.ProjectService = i);
  })((egr = egr || {})),
  (function (e) {
    var Ie, _e;
    (Ie = e.wcf || (e.wcf = {})),
      (function (e) {
        var t,
          o =
            ((t = _e.SoapRequestData),
            __extends(n, t),
            (n.Serialize = function (e) {
              return _e.SoapService.SerializeDataToXml({ AddressData: e });
            }),
            (n.Deserialize = function (e, t) {
              void 0 === t && (t = !0);
              var o = _e.SoapService.DeserializeXmlToObject(e);
              if (null == o || null == o.AddressData) return null;
              var r = n.FromSoap(o.AddressData);
              if (null == r) return null;
              if (t && null != r.contacts)
                for (var a = 0, i = r.contacts; a < i.length; a++) i[a].id = 0;
              return r;
            }),
            (n.prototype._getPropertyValue = function (e) {
              return 'commAddresses' === e
                ? null != this.commAddresses
                  ? { commAddress: this.commAddresses }
                  : void 0
                : 'contacts' === e
                ? null != this.contacts
                  ? { contact: this.contacts }
                  : void 0
                : 'countryCode' !== e || '' !== this.countryCode
                ? t.prototype._getPropertyValue.call(this, e)
                : void 0;
            }),
            (n.FromSoapArray = function (e) {
              return _e.SoapService.SoapDataToArray(e, n.FromSoapNU);
            }),
            (n.FromSoapArrayNU = function (e) {
              return _e.SoapService.SoapDataToArrayNU(e, n.FromSoapNU);
            }),
            (n.FromSoapNU = function (e) {
              if (null == e) throw new Error(Ie.utils.ERR_INVALID_ARGUMENT);
              var t = new n();
              return (
                (t.addressNumber = e.addressNumber),
                (t.addressId = e.addressId),
                (t.title = e.title),
                (t.name1 = e.name1),
                (t.name2 = e.name2),
                (t.name3 = e.name3),
                (t.name4 = e.name4),
                (t.street = e.street),
                (t.street2 = e.street2),
                (t.countryCode = e.countryCode),
                (t.postalCode = e.postalCode),
                (t.location = e.location),
                (t.district = e.district),
                (t.regionCode = e.regionCode),
                (t.poBox = e.poBox),
                (t.taxCode = e.taxCode),
                (t.taxCodeEU = e.taxCodeEU),
                (t.taxCodeUSA = e.taxCodeUSA),
                (t.addressType = e.addressType),
                null != e.commAddresses &&
                  null != e.commAddresses.commAddress &&
                  (t.commAddresses = p.FromSoapArrayNU(
                    e.commAddresses.commAddress
                  )),
                null != e.contacts &&
                  null != e.contacts.contact &&
                  (t.contacts = l.FromSoapArrayNU(e.contacts.contact)),
                t
              );
            }),
            (n.FromSoap = function (e) {
              if (null != e) return n.FromSoapNU(e);
            }),
            __decorate(
              [_e.soapAttribute()],
              n.prototype,
              'addressType',
              void 0
            ),
            n);
        function n() {
          var e = t.call(this) || this;
          return (e.addressType = 'SoldTo'), e;
        }
        e.AddressData = o;
        var r,
          a =
            ((r = _e.SoapRequestData),
            __extends(i, r),
            (i.FromSoap = function (e) {
              if (null != e) {
                var t = new i();
                return (
                  (t.onSessionClose = _e.SoapService.SoapDataToBool(
                    e.onSessionClose
                  )),
                  (t.onProjectClose = _e.SoapService.SoapDataToBool(
                    e.onProjectClose
                  )),
                  (t.periodical = _e.SoapService.SoapDataToBool(e.periodical)),
                  (t.interval = e.interval),
                  (t.idleTime = e.idleTime),
                  t
                );
              }
            }),
            __decorate(
              [_e.soapAttribute()],
              i.prototype,
              'onSessionClose',
              void 0
            ),
            __decorate(
              [_e.soapAttribute()],
              i.prototype,
              'onProjectClose',
              void 0
            ),
            __decorate([_e.soapAttribute()], i.prototype, 'periodical', void 0),
            __decorate([_e.soapAttribute()], i.prototype, 'interval', void 0),
            __decorate([_e.soapAttribute()], i.prototype, 'idleTime', void 0),
            i);
        function i() {
          return (null !== r && r.apply(this, arguments)) || this;
        }
        e.AutoSaveOptions = a;
        var s,
          p =
            ((s = _e.SoapRequestData),
            __extends(u, s),
            (u.FromSoapArrayNU = function (e) {
              return _e.SoapService.SoapDataToArrayNU(e, u.FromSoapNU);
            }),
            (u.FromSoapNU = function (e) {
              var t;
              if (null == e) throw new Error(Ie.utils.ERR_INVALID_ARGUMENT);
              var o = new u();
              return (
                (o.value =
                  null !== (t = _e.SoapService.GetSoapDataNodeValue(e)) &&
                  void 0 !== t
                    ? t
                    : ''),
                (o.type = e.type),
                (o.scope = e.scope),
                o
              );
            }),
            __decorate([_e.soapNodeText()], u.prototype, 'value', void 0),
            __decorate([_e.soapAttribute()], u.prototype, 'type', void 0),
            __decorate([_e.soapAttribute()], u.prototype, 'scope', void 0),
            u);
        function u() {
          var e = s.call(this) || this;
          return (e.value = ''), (e.type = 'Phone'), (e.scope = 'Business'), e;
        }
        e.CommAddress = p;
        var c,
          l =
            ((c = _e.SoapRequestData),
            __extends(d, c),
            (d.prototype._getPropertyValue = function (e) {
              return 'commAddresses' === e
                ? null != this.commAddresses
                  ? { commAddress: this.commAddresses }
                  : void 0
                : c.prototype._getPropertyValue.call(this, e);
            }),
            (d.FromSoapArrayNU = function (e) {
              return _e.SoapService.SoapDataToArrayNU(e, d.FromSoapNU);
            }),
            (d.FromSoapNU = function (e) {
              if (null == e) throw new Error(Ie.utils.ERR_INVALID_ARGUMENT);
              var t = new d();
              return (
                (t.contactNumber = e.contactNumber),
                (t.title = e.title),
                (t.firstName = e.firstName),
                (t.lastName = e.lastName),
                (t.id = e.id),
                (t.contactType = e.contactType),
                null != e.commAddresses &&
                  null != e.commAddresses.commAddress &&
                  (t.commAddresses = p.FromSoapArrayNU(
                    e.commAddresses.commAddress
                  )),
                t
              );
            }),
            __decorate([_e.soapAttribute()], d.prototype, 'id', void 0),
            __decorate(
              [_e.soapAttribute()],
              d.prototype,
              'contactType',
              void 0
            ),
            d);
        function d() {
          var e = c.call(this) || this;
          return (e.id = 0), e;
        }
        e.ContactData = l;
        var m,
          S =
            ((m = _e.SoapRequestData),
            __extends(y, m),
            __decorate(
              [_e.soapAttribute()],
              y.prototype,
              'ignoreVersionNumbers',
              void 0
            ),
            __decorate(
              [_e.soapAttribute()],
              y.prototype,
              'failIfNonExistent',
              void 0
            ),
            __decorate(
              [_e.soapAttribute()],
              y.prototype,
              'failIfPermissionDenied',
              void 0
            ),
            __decorate(
              [_e.soapAttribute()],
              y.prototype,
              'failIfNotLockable',
              void 0
            ),
            __decorate(
              [_e.soapAttribute()],
              y.prototype,
              'ignoreLocks',
              void 0
            ),
            y);
        function y() {
          return (null !== m && m.apply(this, arguments)) || this;
        }
        e.DeleteProjectsOptions = S;
        var f,
          h =
            ((f = _e.SoapRequestData),
            __extends(v, f),
            (v.FromSoapArrayNU = function (e) {
              return _e.SoapService.SoapDataToArrayNU(e, v.FromSoapNU);
            }),
            (v.FromSoapNU = function (e) {
              var t;
              if (null == e) throw new Error(Ie.utils.ERR_INVALID_ARGUMENT);
              var o = new v();
              return (
                (o.value =
                  null !== (t = _e.SoapService.GetSoapDataNodeValue(e)) &&
                  void 0 !== t
                    ? t
                    : ''),
                (o.language = e.language),
                o
              );
            }),
            __decorate([_e.soapNodeText()], v.prototype, 'value', void 0),
            __decorate([_e.soapAttribute()], v.prototype, 'language', void 0),
            v);
        function v() {
          var e = f.call(this) || this;
          return (e.value = ''), (e.language = ''), e;
        }
        e.DisplayName = h;
        var A,
          I =
            ((A = _e.SoapRequestData),
            __extends(_, A),
            __decorate(
              [_e.soapAttribute()],
              _.prototype,
              'projectGroupPattern',
              void 0
            ),
            __decorate(
              [_e.soapAttribute()],
              _.prototype,
              'addressType',
              void 0
            ),
            __decorate(
              [_e.soapAttribute()],
              _.prototype,
              'contactType',
              void 0
            ),
            __decorate([_e.soapAttribute()], _.prototype, 'limit', void 0),
            __decorate(
              [_e.soapAttribute()],
              _.prototype,
              'filterAttribute',
              void 0
            ),
            __decorate([_e.soapAttribute()], _.prototype, 'ignoreCase', void 0),
            _);
        function _() {
          var e = A.call(this) || this;
          return (e.prefix = ''), e;
        }
        e.ListCompletionsOptions = I;
        var g,
          N =
            ((g = _e.SoapRequestData),
            __extends(b, g),
            __decorate(
              [_e.soapAttribute()],
              b.prototype,
              'projectGroupPattern',
              void 0
            ),
            __decorate(
              [_e.soapAttribute()],
              b.prototype,
              'addressType',
              void 0
            ),
            __decorate(
              [_e.soapAttribute()],
              b.prototype,
              'contactType',
              void 0
            ),
            __decorate([_e.soapAttribute()], b.prototype, 'offset', void 0),
            __decorate([_e.soapAttribute()], b.prototype, 'limit', void 0),
            b);
        function b() {
          return (null !== g && g.apply(this, arguments)) || this;
        }
        e.ListProjectsOptions = N;
        var T,
          D =
            ((T = _e.SoapRequestData),
            __extends(x, T),
            (x.FromSoapArrayNU = function (e) {
              return _e.SoapService.SoapDataToArrayNU(e, x.FromSoapNU);
            }),
            (x.FromSoapNU = function (e) {
              if (null == e) throw new Error(Ie.utils.ERR_INVALID_ARGUMENT);
              var t = new x();
              return (
                (t.userRole = e.userRole),
                (t.create = _e.SoapService.SoapDataToBool(e.create)),
                (t.read = _e.SoapService.SoapDataToBool(e.read)),
                (t.write = _e.SoapService.SoapDataToBool(e.write)),
                (t.delete = _e.SoapService.SoapDataToBool(e.delete)),
                (t.list = _e.SoapService.SoapDataToBool(e.list)),
                t
              );
            }),
            (x.FromSoap = function (e) {
              if (null != e) return x.FromSoapNU(e);
            }),
            __decorate([_e.soapAttribute()], x.prototype, 'userRole', void 0),
            __decorate([_e.soapAttribute()], x.prototype, 'create', void 0),
            __decorate([_e.soapAttribute()], x.prototype, 'read', void 0),
            __decorate([_e.soapAttribute()], x.prototype, 'write', void 0),
            __decorate([_e.soapAttribute()], x.prototype, 'delete', void 0),
            __decorate([_e.soapAttribute()], x.prototype, 'list', void 0),
            x);
        function x() {
          return (null !== T && T.apply(this, arguments)) || this;
        }
        e.Permission = D;
        var F,
          U =
            ((F = _e.SoapRequestData),
            __extends(w, F),
            (w.prototype._getPropertyValue = function (e) {
              return 'userRoles' === e
                ? null != this.userRoles
                  ? { userRole: this.userRoles }
                  : void 0
                : 'displayNames' === e
                ? null != this.displayNames
                  ? { displayName: this.displayNames }
                  : void 0
                : F.prototype._getPropertyValue.call(this, e);
            }),
            (w.FromSoapArrayNU = function (e) {
              return _e.SoapService.SoapDataToArrayNU(e, w.FromSoapNU);
            }),
            (w.FromSoapNU = function (e) {
              if (null == e) throw new Error(Ie.utils.ERR_INVALID_ARGUMENT);
              var t = new w();
              return (
                (t.id = e.id),
                (t.startup = e.startup),
                (t.availableToCurrentUser = _e.SoapService.SoapDataToBool(
                  e.availableToCurrentUser
                )),
                null != e.userRoles &&
                  null != e.userRoles.userRole &&
                  (t.userRoles = _e.SoapService.SoapDataToArrayNU(
                    e.userRoles.userRole
                  )),
                null != e.displayNames &&
                  null != e.displayNames.displayName &&
                  (t.displayNames = h.FromSoapArrayNU(
                    e.displayNames.displayName
                  )),
                t
              );
            }),
            __decorate([_e.soapAttribute()], w.prototype, 'id', void 0),
            __decorate([_e.soapAttribute()], w.prototype, 'startup', void 0),
            __decorate(
              [_e.soapAttribute()],
              w.prototype,
              'availableToCurrentUser',
              void 0
            ),
            w);
        function w() {
          var e = F.call(this) || this;
          return (e.id = ''), e;
        }
        e.PriceList = U;
        var P,
          R =
            ((P = _e.SoapRequestData),
            __extends(j, P),
            (j.prototype._getPropertyValue = function (e) {
              return 'addresses' === e
                ? null != this.addresses
                  ? { address: this.addresses }
                  : void 0
                : 'keywords' === e
                ? null != this.keywords
                  ? { keyword: this.keywords }
                  : void 0
                : P.prototype._getPropertyValue.call(this, e);
            }),
            (j.FromSoapArrayNU = function (e) {
              return _e.SoapService.SoapDataToArrayNU(e, j.FromSoapNU);
            }),
            (j.FromSoapNU = function (e) {
              if (null == e) throw new Error(Ie.utils.ERR_INVALID_ARGUMENT);
              var t = new j();
              return (
                (t.uri = e.uri),
                (t.projectName = e.projectName),
                (t.projectNumber = e.projectNumber),
                (t.description = e.description),
                (t.externalReferenceNumber = e.externalReferenceNumber),
                (t.externalReferenceText = e.externalReferenceText),
                (t.customerNumber = e.customerNumber),
                (t.externalCustomerId = e.externalCustomerId),
                (t.customerRelatedRemarks = e.customerRelatedRemarks),
                (t.company = e.company),
                (t.generalAgreementNumber = e.generalAgreementNumber),
                (t.projectGroup = e.projectGroup),
                (t.projectId = e.projectId),
                (t.projectVersion = _e.SoapService.SoapDataToInt(
                  e.projectVersion
                )),
                (t.priceList = e.priceList),
                (t.projectState = e.projectState),
                (t.created = e.created),
                (t.lastModified = e.lastModified),
                (t.projectDate = e.projectDate),
                (t.validToDate = e.validToDate),
                (t.createdByUser = e.createdByUser),
                (t.modifiedByUser = e.modifiedByUser),
                (t.changed = _e.SoapService.SoapDataToBool(e.changed)),
                (t.locked = _e.SoapService.SoapDataToBool(e.locked)),
                (t.lockHolder = e.lockHolder),
                (t.lockTime = e.lockTime),
                (t.projectNumberEditable = _e.SoapService.SoapDataToBool(
                  e.projectNumberEditable
                )),
                null != e.addresses &&
                  null != e.addresses.address &&
                  (t.addresses = o.FromSoapArrayNU(e.addresses.address)),
                null != e.keywords &&
                  null != e.keywords.keyword &&
                  (t.keywords = _e.SoapService.SoapDataToArrayNU(
                    e.keywords.keyword
                  )),
                t
              );
            }),
            (j.FromSoap = function (e) {
              if (null != e) return j.FromSoapNU(e);
            }),
            __decorate(
              [_e.soapAttribute()],
              j.prototype,
              'projectGroup',
              void 0
            ),
            __decorate([_e.soapAttribute()], j.prototype, 'projectId', void 0),
            __decorate(
              [_e.soapAttribute()],
              j.prototype,
              'projectVersion',
              void 0
            ),
            __decorate([_e.soapAttribute()], j.prototype, 'priceList', void 0),
            __decorate(
              [_e.soapAttribute()],
              j.prototype,
              'projectState',
              void 0
            ),
            __decorate([_e.soapAttribute()], j.prototype, 'created', void 0),
            __decorate(
              [_e.soapAttribute()],
              j.prototype,
              'lastModified',
              void 0
            ),
            __decorate(
              [_e.soapAttribute()],
              j.prototype,
              'projectDate',
              void 0
            ),
            __decorate(
              [_e.soapAttribute()],
              j.prototype,
              'validToDate',
              void 0
            ),
            __decorate(
              [_e.soapAttribute()],
              j.prototype,
              'createdByUser',
              void 0
            ),
            __decorate(
              [_e.soapAttribute()],
              j.prototype,
              'modifiedByUser',
              void 0
            ),
            __decorate([_e.soapAttribute()], j.prototype, 'changed', void 0),
            __decorate([_e.soapAttribute()], j.prototype, 'locked', void 0),
            __decorate([_e.soapAttribute()], j.prototype, 'lockHolder', void 0),
            __decorate([_e.soapAttribute()], j.prototype, 'lockTime', void 0),
            __decorate(
              [_e.soapAttribute()],
              j.prototype,
              'projectNumberEditable',
              void 0
            ),
            j);
        function j() {
          return (null !== P && P.apply(this, arguments)) || this;
        }
        e.ProjectData = R;
        var C,
          E = ((C = _e.SoapRequestData), __extends(L, C), L);
        function L() {
          return (null !== C && C.apply(this, arguments)) || this;
        }
        e.ProjectFilterNode = E;
        var O,
          V =
            (__extends(B, (O = E)),
            (B.prototype._getClassName = function () {
              return 'ProjectFilter';
            }),
            __decorate([_e.soapAttribute()], B.prototype, 'operator', void 0),
            __decorate([_e.soapAttribute()], B.prototype, 'ignoreCase', void 0),
            B);
        function B() {
          var e = O.call(this) || this;
          return (e.arguments = new Array()), (e.operator = 'And'), e;
        }
        e.ProjectFilter = V;
        var k,
          M =
            (__extends(G, (k = E)),
            (G.prototype._getClassName = function () {
              return 'ProjectFilterAttribute';
            }),
            __decorate([_e.soapAttribute()], G.prototype, 'attribute', void 0),
            G);
        function G() {
          var e = k.call(this) || this;
          return (e.attribute = 'ProjectName'), e;
        }
        e.ProjectFilterAttribute = M;
        var q,
          X = (__extends(z, (q = E)), z);
        function z() {
          return (null !== q && q.apply(this, arguments)) || this;
        }
        e.ProjectFilterValue = X;
        var K,
          W =
            (__extends(H, (K = X)),
            (H.prototype._getClassName = function () {
              return 'ProjectFilterStringValue';
            }),
            H);
        function H() {
          var e = K.call(this) || this;
          return (e.value = ''), e;
        }
        e.ProjectFilterStringValue = W;
        var Q,
          Y =
            (__extends(J, (Q = X)),
            (J.prototype._getClassName = function () {
              return 'ProjectFilterDateTimeValue';
            }),
            __decorate([_e.soapAttribute()], J.prototype, 'value', void 0),
            J);
        function J() {
          var e = Q.call(this) || this;
          return (e.value = ''), e;
        }
        e.ProjectFilterDateTimeValue = Y;
        var Z,
          $ =
            (__extends(ee, (Z = X)),
            (ee.prototype._getClassName = function () {
              return 'ProjectFilterDateValue';
            }),
            __decorate([_e.soapAttribute()], ee.prototype, 'date', void 0),
            ee);
        function ee() {
          var e = Z.call(this) || this;
          return (e.date = ''), e;
        }
        e.ProjectFilterDateValue = $;
        var te,
          oe =
            (__extends(re, (te = X)),
            (re.prototype._getClassName = function () {
              return 'ProjectFilterStateValue';
            }),
            __decorate([_e.soapAttribute()], re.prototype, 'value', void 0),
            re);
        function re() {
          var e = te.call(this) || this;
          return (e.value = 'Undefined'), e;
        }
        e.ProjectFilterStateValue = oe;
        var ae,
          ie =
            ((ae = _e.SoapRequestData),
            __extends(ne, ae),
            (ne.prototype._getPropertyValue = function (e) {
              return 'priceLists' === e
                ? null != this.priceLists
                  ? { priceList: this.priceLists }
                  : void 0
                : 'permissions' === e
                ? null != this.permissions
                  ? { permission: this.permissions }
                  : void 0
                : 'simpleNames' === e
                ? null != this.simpleNames
                  ? { displayName: this.simpleNames }
                  : void 0
                : 'fullNames' === e
                ? null != this.fullNames
                  ? { displayName: this.fullNames }
                  : void 0
                : 'subgroupTitles' === e
                ? null != this.subgroupTitles
                  ? { displayName: this.subgroupTitles }
                  : void 0
                : ae.prototype._getPropertyValue.call(this, e);
            }),
            (ne.FromSoapArrayNU = function (e) {
              return _e.SoapService.SoapDataToArrayNU(e, ne.FromSoapNU);
            }),
            (ne.FromSoapNU = function (e) {
              if (null == e) throw new Error(Ie.utils.ERR_INVALID_ARGUMENT);
              var t = new ne();
              return (
                (t.numberScheme = pe.FromSoap(e.numberScheme)),
                (t.id = e.id),
                (t.folder = _e.SoapService.SoapDataToBool(e.folder)),
                null != e.priceLists &&
                  null != e.priceLists.priceList &&
                  (t.priceLists = U.FromSoapArrayNU(e.priceLists.priceList)),
                null != e.permissions &&
                  null != e.permissions.permission &&
                  (t.permissions = D.FromSoapArrayNU(e.permissions.permission)),
                null != e.simpleNames &&
                  null != e.simpleNames.displayName &&
                  (t.simpleNames = h.FromSoapArrayNU(
                    e.simpleNames.displayName
                  )),
                null != e.fullNames &&
                  null != e.fullNames.displayName &&
                  (t.fullNames = h.FromSoapArrayNU(e.fullNames.displayName)),
                null != e.subgroupTitles &&
                  null != e.subgroupTitles.displayName &&
                  (t.subgroupTitles = h.FromSoapArrayNU(
                    e.subgroupTitles.displayName
                  )),
                (t.currentUserPermissions = D.FromSoap(
                  e.currentUserPermissions
                )),
                t
              );
            }),
            __decorate([_e.soapAttribute()], ne.prototype, 'id', void 0),
            __decorate([_e.soapAttribute()], ne.prototype, 'folder', void 0),
            ne);
        function ne() {
          var e = ae.call(this) || this;
          return (e.id = ''), e;
        }
        e.ProjectGroup = ie;
        var se,
          pe =
            ((se = _e.SoapRequestData),
            __extends(ue, se),
            (ue.FromSoapArrayNU = function (e) {
              return _e.SoapService.SoapDataToArrayNU(e, ue.FromSoapNU);
            }),
            (ue.FromSoap = function (e) {
              if (null != e) {
                var t = new ue();
                return (
                  (t.id = e.id),
                  (t.pattern = e.pattern),
                  (t.minimumValue = _e.SoapService.SoapDataToInt(
                    e.minimumValue
                  )),
                  (t.maximumValue = _e.SoapService.SoapDataToInt(
                    e.maximumValue
                  )),
                  (t.nextValue = _e.SoapService.SoapDataToInt(e.nextValue)),
                  (t.currentYear = _e.SoapService.SoapDataToInt(e.currentYear)),
                  (t.zoneId = e.zoneId),
                  t
                );
              }
            }),
            (ue.FromSoapNU = function (e) {
              if (null == e) throw new Error(Ie.utils.ERR_INVALID_ARGUMENT);
              return ue.FromSoap(e);
            }),
            __decorate([_e.soapAttribute()], ue.prototype, 'id', void 0),
            __decorate([_e.soapAttribute()], ue.prototype, 'pattern', void 0),
            __decorate(
              [_e.soapAttribute()],
              ue.prototype,
              'minimumValue',
              void 0
            ),
            __decorate(
              [_e.soapAttribute()],
              ue.prototype,
              'maximumValue',
              void 0
            ),
            __decorate([_e.soapAttribute()], ue.prototype, 'nextValue', void 0),
            __decorate(
              [_e.soapAttribute()],
              ue.prototype,
              'currentYear',
              void 0
            ),
            __decorate([_e.soapAttribute()], ue.prototype, 'zoneId', void 0),
            ue);
        function ue() {
          var e = se.call(this) || this;
          return (e.id = ''), e;
        }
        e.ProjectNumberScheme = pe;
        var ce,
          le =
            ((ce = _e.SoapRequestData),
            __extends(de, ce),
            __decorate([_e.soapAttribute()], de.prototype, 'attribute', void 0),
            __decorate([_e.soapAttribute()], de.prototype, 'ascending', void 0),
            __decorate(
              [_e.soapAttribute()],
              de.prototype,
              'undefFirst',
              void 0
            ),
            __decorate(
              [_e.soapAttribute()],
              de.prototype,
              'ignoreCase',
              void 0
            ),
            de);
        function de() {
          var e = ce.call(this) || this;
          return (e.attribute = 'CreateTime'), e;
        }
        e.ProjectSortSpec = le;
        var me,
          Se =
            ((me = _e.SoapRequestData),
            __extends(ye, me),
            __decorate(
              [_e.soapAttribute()],
              ye.prototype,
              'projectGroup',
              void 0
            ),
            __decorate([_e.soapAttribute()], ye.prototype, 'priceList', void 0),
            __decorate(
              [_e.soapAttribute()],
              ye.prototype,
              'noVersionCheck',
              void 0
            ),
            __decorate(
              [_e.soapAttribute()],
              ye.prototype,
              'autoDelete',
              void 0
            ),
            ye);
        function ye() {
          return (null !== me && me.apply(this, arguments)) || this;
        }
        e.SaveProjectOptions = Se;
        var fe =
          ((he.FromSoapArrayNU = function (e) {
            return _e.SoapService.SoapDataToArrayNU(e, he.FromSoapNU);
          }),
          (he.FromSoapNU = function (e) {
            if (null == e) throw new Error(Ie.utils.ERR_INVALID_ARGUMENT);
            var t = new he();
            return (
              (t.displayName = e.displayName),
              (t.iso3166Code = e.iso3166Code),
              t
            );
          }),
          he);
        function he() {}
        e.CountryData = fe;
        var ve =
          ((Ae.FromSoapArrayNU = function (e) {
            return _e.SoapService.SoapDataToArrayNU(e, Ae.FromSoapNU);
          }),
          (Ae.FromSoapNU = function (e) {
            if (null == e) throw new Error(Ie.utils.ERR_INVALID_ARGUMENT);
            var t = new Ae();
            return (
              (t.iso3166names = _e.SoapService.SoapDataToArrayNU(
                e.iso3166names
              )),
              (t.localVariants = _e.SoapService.SoapDataToArray(
                e.localVariants
              )),
              (t.languageCodes = _e.SoapService.SoapDataToArrayNU(
                e.languageCodes
              )),
              (t.displayName = e.displayName),
              (t.category = e.category),
              (t.iso3166Code = e.iso3166Code),
              (t.regionCode = e.regionCode),
              (t.parentSubdivision = e.parentSubdivision),
              t
            );
          }),
          Ae);
        function Ae() {}
        e.SubdivisionData = ve;
      })((_e = Ie.eaiws || (Ie.eaiws = {})).project || (_e.project = {}));
  })((egr = egr || {})),
  (function (e) {
    var r, o, t, a, i;
    function n(e, t, o) {
      return (
        a.call(
          this,
          e,
          r.utils.string.joinPath(t, 'EAI/Session'),
          'http://ws.eai.egr/',
          o
        ) || this
      );
    }
    (r = e.wcf || (e.wcf = {})),
      (o = r.eaiws || (r.eaiws = {})),
      (t = o.session || (o.session = {})),
      (a = o.BaseEaiwsService),
      __extends(n, a),
      (n.GetSystemInformation = function (e, t) {
        return new n(null, e, null).getSystemInformation(t);
      }),
      (n.OpenSession = function (e, t) {
        return new n(null, e, null).soapAjax('openSession', { args: t });
      }),
      (n.prototype.closeSession = function () {
        return this.soapAjax('closeSession', { sessionId: this.mSessionId });
      }),
      (n.prototype.configureSessionLog = function (e, t) {
        return this.soapAjax('configureSessionLog', {
          sessionId: this.mSessionId,
          enable: e,
          config: t,
        });
      }),
      (n.prototype.getLocale = function (e) {
        var t = this;
        return null != this.mLocale
          ? Promise.resolve(this.mLocale)
          : this.soapAjax('getLocale', {
              sessionId: this.mSessionId,
              withTimeZone: e,
            }).then(function (e) {
              return (t.mLocale = e), t.mLocale;
            });
      }),
      (n.prototype.getProjectAppData = function (e, t) {
        return this.soapAjax('getProjectAppData', {
          sessionId: this.mSessionId,
          appKey: null == e ? '' : e,
          paths: t,
        }).then(function (e) {
          return o.SoapService.SoapDataToArrayNU(e);
        });
      }),
      (n.prototype.getProjectSettings = function () {
        return this.soapAjax('getProjectSettings', {
          sessionId: this.mSessionId,
        }).then(function (e) {
          return t.ProjectSettings.FromSoap(e);
        });
      }),
      (n.prototype.getSessionLog = function (e) {
        return this.soapAjax('getSessionLog', {
          sessionId: this.mSessionId,
          reset: e,
        }).then(function (e) {
          return t.LogData.FromSoap(e);
        });
      }),
      (n.prototype.getSessionProperty = function (e) {
        return this.soapAjax('getSessionProperty', {
          sessionId: this.mSessionId,
          name: e,
        });
      }),
      (n.prototype.getSystemInformation = function (e) {
        return this.soapAjax('getSystemInformation', { options: e }).then(
          function (e) {
            return t.SystemInformation.FromSoap(e);
          }
        );
      }),
      (n.prototype.getUploadURL = function (e, t) {
        return this.soapAjax('getUploadURL', {
          sessionId: this.mSessionId,
          fileType: e,
          suffix: t,
        });
      }),
      (n.prototype.importFile = function (e, t, o) {
        return this.soapAjax('importFile', {
          sessionId: this.mSessionId,
          url: e,
          attributes: t,
          options: o,
        });
      }),
      (n.prototype.keepAlive = function () {
        return this.soapAjax('keepAlive', { sessionId: this.mSessionId }).then(
          function (e) {
            return 'true' === e;
          }
        );
      }),
      (n.prototype.loadEmptySession = function () {
        var e = this;
        return this.soapAjax('loadEmptySession', {
          sessionId: this.mSessionId,
        }).then(function () {
          e.mOwner._clearCache();
        });
      }),
      (n.prototype.loadSession = function (e, t) {
        return this.soapAjax('loadSession', {
          sessionId: this.mSessionId,
          uri: null == e ? '' : e,
          options: t,
        });
      }),
      (n.prototype.resolveURIs = function (e, t) {
        return this.soapAjax('resolveURIs', {
          sessionId: this.mSessionId,
          uris: e,
          options: t,
        }).then(function (e) {
          return o.SoapService.SoapDataToArrayNU(e);
        });
      }),
      (n.prototype.saveSession = function (e, t) {
        return this.soapAjax('saveSession', {
          sessionId: this.mSessionId,
          uri: null == e ? '' : e,
          options: null == t ? null : t,
        });
      }),
      (n.prototype.setLocale = function (e, t, o) {
        var r = this;
        return this.soapAjax('setLocale', {
          sessionId: this.mSessionId,
          name: null == e ? '' : e,
          timeZone: t,
          tzOffset: o,
        }).then(function () {
          (r.mLocale = void 0), r.mOwner.eventSessionLocaleChanged.trigger();
        });
      }),
      (n.prototype.setProjectAppData = function (e, t) {
        return this.soapAjax('setProjectAppData', {
          sessionId: this.mSessionId,
          appKey: null == e ? '' : e,
          data: t,
        });
      }),
      (n.prototype.setProjectSettings = function (e) {
        return this.soapAjax('setProjectSettings', {
          sessionId: this.mSessionId,
          settings: e,
        });
      }),
      (n.prototype.setSessionProperty = function (e, t) {
        return this.soapAjax('setSessionProperty', {
          sessionId: this.mSessionId,
          name: e,
          value: t,
        });
      }),
      (n.prototype._clearCache = function () {
        this.mLocale = void 0;
      }),
      (i = n),
      (t.SessionService = i);
  })((egr = egr || {})),
  (function (e) {
    var J, Z;
    (J = e.wcf || (e.wcf = {})),
      (function (e) {
        var t,
          o =
            ((t = Z.SoapRequestData),
            __extends(r, t),
            (r.FromSoap = function (e) {
              if (null != e) {
                var t = new r();
                return (
                  (t.customerNumber = e.customerNumber),
                  (t.salutation = e.salutation),
                  (t.firstName = e.firstName),
                  (t.lastName = e.lastName),
                  (t.emailAddr = e.emailAddr),
                  (t.company = e.company),
                  (t.organization = e.organization),
                  (t.streetAddr = e.streetAddr),
                  (t.city = e.city),
                  (t.stateOrProvince = e.stateOrProvince),
                  (t.cityCode = e.cityCode),
                  (t.poBox = e.poBox),
                  (t.postalCode = e.postalCode),
                  (t.poBoxPostalCode = e.poBoxPostalCode),
                  (t.country = e.country),
                  (t.language = e.language),
                  (t.phone = e.phone),
                  (t.fax = e.fax),
                  t
                );
              }
            }),
            r);
        function r() {
          return (null !== t && t.apply(this, arguments)) || this;
        }
        e.CustomerData = o;
        var a,
          i =
            ((a = Z.SoapRequestData),
            __extends(n, a),
            __decorate(
              [Z.soapAttribute()],
              n.prototype,
              'operatingSystem',
              void 0
            ),
            __decorate([Z.soapAttribute()], n.prototype, 'runtime', void 0),
            __decorate([Z.soapAttribute()], n.prototype, 'memory', void 0),
            __decorate([Z.soapAttribute()], n.prototype, 'application', void 0),
            __decorate([Z.soapAttribute()], n.prototype, 'server', void 0),
            n);
        function n() {
          return (null !== a && a.apply(this, arguments)) || this;
        }
        e.GetSystemInformationOptions = i;
        var s,
          p = ((s = Z.SoapRequestData), __extends(u, s), u);
        function u() {
          return (null !== s && s.apply(this, arguments)) || this;
        }
        e.ImportFileOptions = p;
        var c,
          l =
            ((c = Z.SoapRequestData),
            __extends(d, c),
            __decorate(
              [Z.soapAttribute()],
              d.prototype,
              'assignNewProjectId',
              void 0
            ),
            d);
        function d() {
          return (null !== c && c.apply(this, arguments)) || this;
        }
        e.LoadSessionOptions = l;
        var m,
          S =
            ((m = Z.SoapRequestData),
            __extends(y, m),
            __decorate(
              [Z.soapAttribute()],
              y.prototype,
              'maxRecordCount',
              void 0
            ),
            __decorate(
              [Z.soapAttribute()],
              y.prototype,
              'discardOldest',
              void 0
            ),
            __decorate(
              [Z.soapAttribute()],
              y.prototype,
              'storeStackTrace',
              void 0
            ),
            __decorate([Z.soapAttribute()], y.prototype, 'timeZoneId', void 0),
            y);
        function y() {
          return (null !== m && m.apply(this, arguments)) || this;
        }
        e.LogConfig = S;
        var f,
          h = ((f = Z.SoapRequestData), __extends(v, f), v);
        function v() {
          return (null !== f && f.apply(this, arguments)) || this;
        }
        e.LogFilter = h;
        var A,
          I =
            ((A = Z.SoapRequestData),
            __extends(_, A),
            __decorate([Z.soapAttribute()], _.prototype, 'level', void 0),
            __decorate([Z.soapAttribute()], _.prototype, 'facility', void 0),
            __decorate([Z.soapAttribute()], _.prototype, 'origin', void 0),
            _);
        function _() {
          return (null !== A && A.apply(this, arguments)) || this;
        }
        e.LogFilterSpec = I;
        var g,
          N =
            ((g = Z.SoapRequestData),
            __extends(b, g),
            (b.FromSoap = function (e) {
              if (null != e) {
                var t = new b();
                return (
                  (t.number = e.number),
                  (t.name = e.name),
                  (t.description = e.description),
                  (t.personInCharge = e.personInCharge),
                  (t.extRefNr = e.extRefNr),
                  (t.extRefText = e.extRefText),
                  t
                );
              }
            }),
            b);
        function b() {
          return (null !== g && g.apply(this, arguments)) || this;
        }
        e.ProjectData = N;
        var T,
          D =
            ((T = Z.SoapRequestData),
            __extends(x, T),
            (x.FromSoap = function (e) {
              if (null != e) {
                var t = new x();
                return (
                  (t.projectData = N.FromSoap(e.projectData)),
                  (t.customerData = o.FromSoap(e.customerData)),
                  t
                );
              }
            }),
            x);
        function x() {
          return (null !== T && T.apply(this, arguments)) || this;
        }
        e.ProjectSettings = D;
        var F,
          U =
            ((F = Z.SoapRequestData),
            __extends(w, F),
            __decorate([Z.soapAttribute()], w.prototype, 'serverBase', void 0),
            w);
        function w() {
          return (null !== F && F.apply(this, arguments)) || this;
        }
        e.ResolveURIsOptions = U;
        var P,
          R = ((P = Z.SoapRequestData), __extends(j, P), j);
        function j() {
          return (null !== P && P.apply(this, arguments)) || this;
        }
        e.SaveSessionOptions = R;
        var C,
          E = ((C = Z.SoapRequestData), __extends(L, C), L);
        function L(e, t) {
          void 0 === e && (e = ''), void 0 === t && (t = '');
          var o = C.call(this) || this;
          return (o.first = e), (o.second = t), o;
        }
        e.StringPair = E;
        var O =
          ((V.FromSoap = function (e) {
            if (null != e) {
              var t = new V();
              return (
                (t.appName = e.appName),
                (t.appKey = e.appKey),
                (t.appVersion = e.appVersion),
                (t.vendorKey = e.vendorKey),
                t
              );
            }
          }),
          V);
        function V() {}
        e.ApplicationInformation = O;
        var B =
          ((k.FromSoapArray = function (e) {
            return Z.SoapService.SoapDataToArray(e, k.FromSoapNU);
          }),
          (k.FromSoapArrayNU = function (e) {
            return Z.SoapService.SoapDataToArrayNU(e, k.FromSoapNU);
          }),
          (k.FromSoap = function (e) {
            if (null != e) {
              var t = new k();
              return (
                (t.className = e.className),
                (t.methodName = e.methodName),
                (t.fileName = e.fileName),
                (t.lineNumber = Z.SoapService.SoapDataToInt(e.lineNumber)),
                t
              );
            }
          }),
          (k.FromSoapNU = function (e) {
            var t = k.FromSoap(e);
            if (null == t) throw new Error(J.utils.ERR_INVALID_ARGUMENT);
            return t;
          }),
          k);
        function k() {}
        e.CallSite = B;
        var M =
          ((G.FromSoapArray = function (e) {
            return Z.SoapService.SoapDataToArray(e, G.FromSoapNU);
          }),
          (G.FromSoapNU = function (e) {
            if (null == e) throw new Error(J.utils.ERR_INVALID_ARGUMENT);
            var t = new G();
            return (
              (t.message = e.message),
              (t.stackTrace = B.FromSoapArrayNU(e.stackTrace)),
              (t.type = e.type),
              t
            );
          }),
          G);
        function G() {}
        e.FaultInfo = M;
        var q =
          ((X.FromSoap = function (e) {
            if (null != e) {
              var t = new X();
              return (
                (t.data = z.FromSoapArrayNU(e.data)),
                (t.discarded = Z.SoapService.SoapDataToInt(e.discarded)),
                (t.suppressed = Z.SoapService.SoapDataToInt(e.suppressed)),
                t
              );
            }
          }),
          X);
        function X() {}
        e.LogData = q;
        var z =
          ((K.FromSoapArrayNU = function (e) {
            return Z.SoapService.SoapDataToArrayNU(e, K.FromSoapNU);
          }),
          (K.FromSoapNU = function (e) {
            if (null == e) throw new Error(J.utils.ERR_INVALID_ARGUMENT);
            var t = new K();
            return (
              (t.cause = M.FromSoapArray(e.cause)),
              (t.message = e.message),
              (t.origin = B.FromSoap(e.origin)),
              (t.facility = e.facility),
              (t.level = e.level),
              (t.timeStamp = e.timeStamp),
              t
            );
          }),
          K);
        function K() {}
        e.LogRecord = z;
        var W =
          ((H.FromSoap = function (e) {
            if (null != e) {
              var t = new H();
              return (
                (t.maxConcurrentSessionCount = e.maxConcurrentSessionCount),
                (t.openSessionCount = e.openSessionCount),
                (t.sessionTimeout = e.sessionTimeout),
                (t.sessionSuspendTimeout = e.sessionSuspendTimeout),
                t
              );
            }
          }),
          H);
        function H() {}
        e.ServerInformation = W;
        var Q =
          ((Y.FromSoap = function (e) {
            if (null != e) {
              var t = new Y();
              return (
                (t.operatingSystem = e.operatingSystem),
                (t.runtime = e.runtime),
                (t.memory = e.memory),
                (t.application = O.FromSoap(e.application)),
                (t.server = W.FromSoap(e.server)),
                t
              );
            }
          }),
          Y);
        function Y() {}
        e.SystemInformation = Q;
      })((Z = J.eaiws || (J.eaiws = {})).session || (Z.session = {}));
  })((egr = egr || {}));
